<template>
  <div class="implantation">
    <Header
      currentPage="implantation"
      :state="state"
      :currentState="currentState"
      v-on:changeState="changeState($event)"
    >
    </Header>
    <TopSection currentPage="implantation"></TopSection>
    <router-link to="/check" class="main-btn sticky">
      <div class="main-btn__text" @click="setRestart"
           onclick="gtag('event', 'click', {'event_category': 'Оцінити необхідність ІКД'})">
        Оцінити необхідність ІКД
      </div>
      <div class="after main-btn__decor">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L8 8L1 15" stroke="#285EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </router-link>
    <section class="section section-2" id="banner">
      <img class="section-2__img desc" src="@/assets/img/implantation/blue-banner-ph-1.png" alt="">
      <img class="section-2__img mob" src="@/assets/img/implantation/blue-banner-ph-1-mob.png" alt="">
      <div class="section-2__content">
        <h2 class="section-2__subtitle">Імплантований<br> кардіовертер-<br>
          <nobr>дефібрилятор (ІКД) –</nobr>
        </h2>
        <p class="section-2__text">це високотехнологічний прилад, який відстежує роботу серця, та в разі виникнення
          загрозливої аритмії запобігає розвитку раптової серцевої смерті.</p>
      </div>
    </section>
    <section class="section section-3 anchor" id="topicality">
      <div class="section-3__left">
        <div class="section-3__img-wrapper">
          <img src="@/assets/img/implantation/section-3-photo.png" alt="">
          <div class="section-3__icon-wrapper icon-wrapper rings"></div>
          <div class="section-3__icon-wrapper icon-wrapper rings"></div>
          <div class="section-3__icon-wrapper icon-wrapper rings"></div>
          <svg width="151" height="151" viewBox="0 0 151 151" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_501_17547)">
              <circle cx="75.5" cy="70.5" r="60.5" fill="#FB35A2"/>
            </g>
            <path
              d="M69.4111 100.792C68.8205 100.226 54.9795 86.8359 53.0043 84.8577C52.8703 84.7235 52.4038 84.3309 51.9572 83.9531C49.451 81.8507 44.2402 77.4719 40.6571 71.8158C35.9723 64.43 35.6695 57.2032 39.7787 50.9208C43.6446 45.0112 48.9597 41.7507 55.1532 41.4923L56.637 41.4326L61.838 59.4895H52.5775L68.8999 82.3527L64.6022 63.9628H73.4011L68.2945 49.6236L69.3813 48.5351C72.7758 45.1355 79.5251 41.4724 86.3191 41.4724C90.8798 41.4724 97.3859 43.1126 102.493 50.9159C106.602 57.1983 106.299 64.425 101.619 71.8108C98.036 77.4669 92.8252 81.8457 90.319 83.9481C89.8674 84.3259 89.4059 84.7136 89.2719 84.8527C87.2967 86.8309 73.4507 100.221 72.8651 100.787L71.1431 102.452L69.4111 100.792Z"
              stroke="white" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M106.88 75.6634C115.272 65.7697 115.178 55.4902 109.461 46.7442C104.081 38.5226 96.1675 33.9913 87.1781 33.9913C81.6443 33.9913 76.2339 35.7722 71.8306 38.2209"
              stroke="white" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M45.1401 88.2643L65.232 107.612" stroke="white" stroke-width="4" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <defs>
              <filter id="filter0_d_501_17547" x="0" y="0" width="151" height="151" filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                               result="hardAlpha"/>
                <feOffset dy="5"/>
                <feGaussianBlur stdDeviation="7.5"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_501_17547"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_501_17547" result="shape"/>
              </filter>
            </defs>
          </svg>
        </div>
        <div class="section-3__left--text-wrapper">
          <p class="section-3__text">В Україні <strong>щороку</strong> від раптової серцевої смерті (РСС)</p>
          <h3 class="section-3__subtitle">помирає близько<br> <span>50 000</span> пацієнтів</h3>
        </div>
      </div>
      <div class="section-3__right">
        <ul class="section-3__right--list list">
          <li class="list__item">
            Наприклад, <strong> у Західній Європі імплантується<br> 185 ІКД</strong> на мільйон населення,<br>
            <span>в Україні — лише 10. </span>
          </li>
          <li class="list__item">
            І хоча <strong>кількість закуплених ІКД, за<br> державний кошт зростає —</strong> з 2019 по 2021 роки
            кількість зросла з 356 до 706.
            <span>для покриття усіх потреб цього недостатньо</span>
            За самими скромними підрахунками<br>
            щорічна потреба складає <strong>більше 3,5 тис <br>
            імплантацій.</strong>
          </li>
          <li class="list__item">
            При цьому в більшості випадків <strong>(90%)</strong> у нас йдеться про вторинну профілактику РСС, коли в
            анамнезі у пацієнта<br>
            <span>вже був епізод зупинки серцевої діяльності<sup>2</sup>.</span>
          </li>
        </ul>
      </div>
    </section>
    <section class="section section-4 anchor" id="implantation-count">
      <div class="section-4__left">
        <h3 class="section-4__title">Кількість імплантацій ІКД в Україні<sup>2</sup></h3>
        <router-link to="/risk" class="main-btn desc"
                     onclick="gtag('event', 'click', {'event_category': 'Детальніше про ризик РСС'})">
          <div class="main-btn__text">
            Детальніше<br>про ризик РСС
          </div>
          <div class="after main-btn__decor">
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L8 8L1 15" stroke="#285EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </router-link>
      </div>
      <div class="section-4__right">
        <div class="chart">
          <div class="chart__bar">
            <div class="count">44</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2010</div>
          </div>
          <div class="chart__bar">
            <div class="count">28</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2011</div>
          </div>
          <div class="chart__bar">
            <div class="count">52</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2012</div>
          </div>
          <div class="chart__bar">
            <div class="count">71</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2013</div>
          </div>
          <div class="chart__bar">
            <div class="count">57</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2014</div>
          </div>
          <div class="chart__bar">
            <div class="count">52</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2015</div>
          </div>
          <div class="chart__bar">
            <div class="count">49</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2016</div>
          </div>
          <div class="chart__bar">
            <div class="count">71</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2017</div>
          </div>
          <div class="chart__bar">
            <div class="count">166</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2018</div>
          </div>
          <div class="chart__bar">
            <div class="count">266</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2019</div>
          </div>
          <div class="chart__bar">
            <div class="count">356</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2020</div>
          </div>
          <div class="chart__bar">
            <div class="count">402</div>
            <img src="@/assets/img/implantation/Ellipse.svg">
            <div class="year">2021</div>
          </div>
        </div>
      </div>
      <router-link to="/risk" class="main-btn mob">
        <div class="main-btn__text">
          Детальніше<br>про ризик РСС
        </div>
        <div class="after main-btn__decor">
          <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L8 8L1 15" stroke="#285EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </router-link>
    </section>
    <section class="section section-5 anchor" id="how-works">
      <h2 class="section-5__title">Як працює ІКД?</h2>
      <div class="section-5__container">
        <img src="@/assets/img/implantation/implant-how-work.png">
        <!-- <div class="video-btn"></div> -->
      </div>
    </section>
    <section class="section section-6 anchor" id="composition">
      <div class="section-6__left">
        <div class="img-decor top">
          <div class="img-decor__inside"></div>
        </div>
        <div class="img-decor bottom">
          <div class="img-decor__inside"></div>
        </div>
        <img src="@/assets/img/implantation/ikd.png">
      </div>
      <div class="section-6__right">
        <h2 class="section-6__subtitle">До складу ІКД входять:</h2>
        <ul class="list">
          <li class="list__item">
            <div class="list__decor">
              <svg width="323" height="270" viewBox="0 0 323 270" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M50 26H179V147H320"
                  stroke-dasharray="500"
                  stroke-dashoffset="0"
                  stroke="#285EFF"
                >
                </path>
                <path
                  d="M154 201H266.007V265H320"
                  stroke="#285EFF"
                  stroke-dasharray="500"
                  stroke-dashoffset="0"
                >
                </path>
                <circle cx="318" cy="147" r="5" fill="#285EFF"/>
                <circle cx="318" cy="265" r="5" fill="#285EFF"/>
                <circle cx="129" cy="202" r="17" fill="#285EFF"/>
                <circle cx="129" cy="202" r="23.5" stroke="#285EFF" stroke-width="3"/>
                <circle cx="25" cy="25" r="17" fill="#285EFF"/>
                <circle cx="25" cy="25" r="23.5" stroke="#285EFF" stroke-width="3"/>
              </svg>
            </div>
            прилад, який імплантують підшкірно в зоні передньої стінки грудної клітки і до якого приєднуються електроди
          </li>
          <li class="list__item">від одного до трьох електродів (залежно від модифікації), які фіксуються у відповідних
            ділянках серця<sup>1</sup>.
          </li>
        </ul>
      </div>
    </section>
    <section class="section-7 anchor" id="function">
      <h2 class="section-7__subtitle">Функції ІКД:</h2>
      <ul class="section-7__list">
        <li class="section-7__item">
          <div class="section-7__item--container">
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_602_17548)">
                <circle cx="60.0001" cy="55.0001" r="44.8742" fill="#285EFF"/>
              </g>
              <path
                d="M61.4397 70.8264C61.4392 72.3851 61.4386 73.9092 61.4365 75.5481C62.1499 75.5258 62.9009 75.4847 63.6536 75.4829C64.6042 75.481 65.0534 75.9208 65.0531 76.8635C65.0577 81.6307 65.0734 86.3964 65.0419 91.162C65.0236 93.9699 62.8687 96.1028 60.1441 96.1006C57.4117 96.0968 55.2708 93.9654 55.256 91.1591C55.2341 86.3935 55.2499 81.6278 55.2578 76.8606C55.2597 75.9226 55.7077 75.484 56.6614 75.4821C57.4125 75.4819 58.1651 75.5178 58.869 75.5364C58.8696 73.9054 58.8701 72.3813 58.8707 70.8351C51.5833 70.316 45.524 67.2651 40.9552 61.4955C36.867 56.329 35.1689 50.3777 35.8704 43.8237C37.2513 30.9106 48.3006 21.4729 61.3325 21.9869C73.8647 22.4791 84.1466 32.9087 84.5964 45.4708C85.0664 58.5215 75.0503 70.0455 61.4397 70.8264ZM75.7381 61.9941C84.3674 53.3775 84.3816 39.4435 75.7693 30.8155C67.1649 22.1954 53.2168 22.1924 44.5891 30.8075C35.963 39.4241 35.9488 53.3581 44.5611 61.9829C53.1733 70.6077 67.1089 70.6139 75.7381 61.9941ZM57.5499 77.8984C57.5828 78.1451 57.6409 78.3823 57.6424 78.6196C57.6473 82.6295 57.6443 86.6378 57.6429 90.6476C57.6429 90.8645 57.6365 91.0844 57.649 91.3013C57.7473 93.2449 59.8006 94.3425 61.4665 93.3332C62.3529 92.7955 62.669 91.9673 62.6662 90.9617C62.6582 86.7539 62.6659 82.546 62.6658 78.3398C62.6659 78.1858 62.6471 78.0349 62.6377 77.8904C60.9784 77.8941 59.3522 77.8962 57.5499 77.8984Z"
                fill="white"/>
              <path
                d="M73.1633 59.6686C66.611 66.2118 56.1705 66.8618 48.8562 61.1787C41.4556 55.4305 39.465 45.2171 44.1768 37.153C49.0542 28.8022 59.7795 25.6991 68.4087 30.14C69.109 30.4996 69.3748 31.1423 69.0754 31.7354C68.7549 32.3678 68.1162 32.5372 67.3569 32.1699C62.7288 29.9359 58.0431 29.7612 53.3623 31.8589C44.0928 36.0166 41.025 47.712 46.9957 55.9773C51.8965 62.7596 60.9918 64.7357 68.2277 60.5917C75.4922 56.4312 78.3296 47.2163 74.6751 39.666C74.5993 39.5118 74.5143 39.3605 74.4475 39.2032C74.159 38.5287 74.3782 37.8765 74.9835 37.6043C75.5616 37.3442 76.1801 37.5888 76.5078 38.221C77.6942 40.5111 78.3627 42.9465 78.5178 45.5139C78.8406 50.8783 76.9295 55.9055 73.1633 59.6686Z"
                fill="white"/>
              <path
                d="M59.1179 44.794C60.7518 43.1524 62.2611 41.6019 63.8127 40.0936C64.9108 39.0251 66.249 38.6963 67.7183 39.1473C69.1854 39.5982 70.1079 40.6156 70.4213 42.1195C70.7192 43.5478 70.2879 44.7829 69.2587 45.8114C67.6849 47.3842 66.1134 48.9569 64.5396 50.5297C63.4726 51.5959 62.41 52.6711 61.3342 53.7285C59.996 55.0435 58.2799 55.0391 56.9462 53.7151C55.2412 52.0224 53.5318 50.3319 51.8491 48.6148C50.7043 47.4486 50.3731 46.0402 50.911 44.5008C51.4601 42.9281 52.6338 42.0551 54.2832 41.8818C55.4969 41.7529 56.555 42.1683 57.4241 43.0214C57.9865 43.5767 58.5178 44.1632 59.1179 44.794ZM68.2273 42.9614C68.1095 42.2328 67.7138 41.673 67.0825 41.4508C66.3734 41.1976 65.8088 41.4508 65.3087 41.9507C63.5837 43.6767 61.861 45.4049 60.1294 47.1243C59.4625 47.7885 58.8356 47.7862 58.1643 47.1265C57.3708 46.349 56.5994 45.5493 55.8014 44.7763C55.0879 44.0854 54.1587 44.0699 53.5163 44.7096C52.8894 45.3338 52.9094 46.2935 53.5985 46.9932C55.259 48.6726 56.9395 50.3297 58.6 52.0069C58.9668 52.3756 59.2847 52.4045 59.6625 52.0246C62.31 49.3679 64.9708 46.7289 67.6027 44.0588C67.8917 43.77 68.0228 43.3301 68.2273 42.9614Z"
                fill="white"/>
              <path
                d="M73.2254 33.4195C73.817 34.0085 73.9771 34.8271 73.5739 35.2066C73.1812 35.5756 72.401 35.4167 71.8278 34.8488C71.2387 34.265 71.076 33.4411 71.4793 33.0616C71.866 32.6947 72.6594 32.8561 73.2254 33.4195Z"
                fill="white"/>
              <defs>
                <filter id="filter0_d_602_17548" x="0.125977" y="0.125977" width="119.749" height="119.749"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                 result="hardAlpha"/>
                  <feOffset dy="5"/>
                  <feGaussianBlur stdDeviation="7.5"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_602_17548"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_602_17548" result="shape"/>
                </filter>
              </defs>
            </svg>
          </div>
          <div class="section-7__text">Постійний контроль за роботою серця</div>
        </li>
        <li class="section-7__item">
          <div class="section-7__item--container">
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_602_17549)">
                <circle cx="60.0001" cy="55.0001" r="44.8742" fill="#285EFF"/>
              </g>
              <path
                d="M54.1365 57.6174C54.6838 56.1455 55.1875 54.7963 55.6872 53.4471C56.8492 50.3115 58.0092 47.1739 59.1732 44.0402C59.2624 43.8008 59.3537 43.5536 59.4905 43.3379C60.014 42.509 61.2137 42.5169 61.7253 43.3518C61.8482 43.5516 61.9275 43.7811 62.0108 44.0026C63.3355 47.5418 64.6561 51.085 65.9807 54.6242C66.0561 54.826 66.1433 55.0238 66.2365 55.2493C68.6657 55.2493 71.0888 55.2474 73.51 55.2533C73.7857 55.2533 74.0692 55.2731 74.333 55.3463C74.9457 55.5184 75.3007 56.0743 75.2451 56.7073C75.1916 57.3068 74.7593 57.7737 74.1525 57.8666C73.9384 57.9003 73.7183 57.9062 73.5001 57.9062C70.8985 57.9082 68.2948 57.9102 65.6932 57.9062C64.5808 57.9042 64.2793 57.6926 63.8887 56.646C62.8139 53.7735 61.7411 50.901 60.6228 47.9098C60.5077 48.1828 60.4264 48.3529 60.361 48.527C58.8837 52.5173 57.4084 56.5075 55.9311 60.4978C55.8478 60.7194 55.7724 60.9489 55.6634 61.1566C55.1934 62.0488 54.0948 62.1655 53.4365 61.392C53.3096 61.2416 53.2045 61.0715 53.0954 60.9053C51.6578 58.6956 50.2201 56.4858 48.7825 54.276C48.6675 54.098 48.5465 53.9239 48.3918 53.6924C47.7077 54.8319 47.0454 55.8864 46.4347 56.9685C46.0619 57.6273 45.5542 57.9201 44.7947 57.9161C40.0872 57.9003 35.3777 57.9121 30.6701 57.9062C29.4307 57.9042 28.7427 57.1248 29.0897 56.1455C29.288 55.5817 29.7679 55.2652 30.4896 55.2493C31.0845 55.2355 31.6794 55.2474 32.3596 55.2474C32.1653 54.7805 31.9868 54.369 31.8222 53.9535C30.3092 50.1295 29.7837 46.2223 30.7712 42.1549C32.3774 35.5315 38.2549 30.1465 45.0327 29.2147C50.5731 28.4531 55.4413 29.9329 59.6015 33.6818C59.7622 33.8262 59.9267 33.9686 60.1112 34.1308C60.7933 33.569 61.4397 32.9894 62.1318 32.473C72.6296 24.629 87.7755 30.7954 89.81 43.7237C90.2701 46.6496 89.8774 49.4707 89.0565 52.2838C88.1384 55.4274 86.4469 58.1317 84.4263 60.6501C80.4127 65.6473 75.6477 69.871 70.5534 73.7208C67.4858 76.0394 64.2813 78.18 61.1443 80.4075C60.48 80.8803 59.8593 80.8784 59.1673 80.4273C52.6354 76.168 46.4525 71.4675 40.8189 66.0667C40.2181 65.4911 39.6351 64.8936 39.0561 64.2942C38.4056 63.6176 38.368 62.854 38.9331 62.2862C39.4784 61.7402 40.2736 61.7817 40.9478 62.4207C42.548 63.9341 44.0967 65.5029 45.7406 66.9669C50.1487 70.8918 54.888 74.3915 59.8018 77.6597C60.0556 77.8278 60.2262 77.8377 60.482 77.6656C67.4561 72.9592 74.1664 67.9323 79.9388 61.7699C82.2767 59.2752 84.4639 56.6381 85.7965 53.4471C87.6486 49.0097 88.0848 44.513 85.8817 40.05C83.7064 35.6423 80.1787 32.8726 75.3344 31.9765C69.9447 30.9794 65.3422 32.5779 61.5805 36.5642C61.4437 36.7086 61.3148 36.8589 61.174 36.9994C60.5117 37.6542 59.7661 37.6265 59.082 36.9816C58.1322 36.0874 57.2279 35.1141 56.169 34.3663C52.7405 31.9409 48.9114 31.1851 44.7928 31.9824C38.4988 33.1931 33.7139 38.4159 33.0199 44.7722C32.6233 48.4103 33.5732 51.7537 35.2587 54.9328C35.342 55.0911 35.6196 55.2375 35.808 55.2394C38.5286 55.2592 41.2512 55.2612 43.9738 55.2375C44.1721 55.2355 44.4438 55.0535 44.5548 54.8774C45.3996 53.5144 46.2106 52.1276 47.0395 50.7526C47.7811 49.5241 48.8578 49.5103 49.6471 50.719C51.1164 52.9723 52.5838 55.2315 54.1365 57.6174Z"
                fill="white"/>
              <path
                d="M60.1347 75.3091C59.8808 75.3091 59.627 75.234 59.4089 75.0856C54.6994 71.8787 50.6819 68.7787 47.1264 65.6134C46.595 65.1406 46.5494 64.3275 47.0233 63.7973C47.4972 63.2671 48.3122 63.2216 48.8437 63.6945C52.1314 66.6224 55.8316 69.4969 60.1347 72.4623C65.0326 69.0755 71.1599 64.5254 76.5318 58.7902C78.4672 56.7229 80.4085 54.4518 81.4932 51.8523C83.0319 48.1667 83.0974 45.13 81.6994 42.297C80.1348 39.1278 77.8425 37.3631 74.4834 36.7419C70.7415 36.0495 67.6798 37.0763 64.9731 39.9448C64.4853 40.4612 63.6703 40.4869 63.1508 40.0002C62.6332 39.5135 62.6074 38.7005 63.0952 38.1821C65.7365 35.3809 68.8379 33.9624 72.312 33.9624C73.1627 33.9624 74.0511 34.0475 74.9533 34.2136C79.1215 34.9852 82.0861 37.2583 84.0115 41.1615C85.7625 44.7106 85.7169 48.4219 83.8707 52.8414C82.6274 55.8168 80.5136 58.3016 78.4136 60.545C72.6016 66.751 65.9824 71.5741 60.8644 75.0836C60.6463 75.234 60.3905 75.3091 60.1347 75.3091Z"
                fill="white"/>
              <defs>
                <filter id="filter0_d_602_17549" x="0.125977" y="0.125977" width="119.749" height="119.749"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                 result="hardAlpha"/>
                  <feOffset dy="5"/>
                  <feGaussianBlur stdDeviation="7.5"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_602_17549"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_602_17549" result="shape"/>
                </filter>
              </defs>
            </svg>
          </div>
          <div class="section-7__text">Збір показників роботи серця</div>
        </li>
        <li class="section-7__item">
          <div class="section-7__item--container">
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <div class="section-3__icon-wrapper icon-wrapper rings"></div>
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_602_17550)">
                <circle cx="60.0001" cy="55.0001" r="44.8742" fill="#285EFF"/>
              </g>
              <path
                d="M51.4596 40.2246C52.5826 39.3952 53.612 38.5372 54.7324 37.8248C59.6273 34.7126 64.8289 34.3382 70.2411 36.2388C71.164 36.5638 72.0582 36.9798 72.9446 37.3984C73.9376 37.8664 74.4316 38.6958 74.5121 39.7826C74.6473 41.6234 74.0858 43.2302 72.8251 44.5666C71.9386 45.5052 70.8832 45.8406 69.5938 45.383C67.938 44.7954 66.2093 44.577 64.452 44.603C64.2778 44.6056 64.1011 44.6264 63.7969 44.6472C65.302 45.6274 66.4198 46.8208 67.3401 48.2014C69.0661 50.791 70.0332 53.6744 70.5869 56.7112C70.6908 57.278 70.3165 57.7668 69.7784 57.85C69.2819 57.9254 68.827 57.5926 68.7152 57.0128C68.2915 54.8184 67.6598 52.6942 66.6226 50.7052C65.8687 49.2622 64.9667 47.9336 63.6981 46.8884C62.9885 46.3034 62.1982 45.8796 61.2832 45.6846C60.6853 45.5572 60.1888 45.6456 59.7755 46.1162C59.6663 46.241 59.5415 46.358 59.4063 46.4542C59.0086 46.735 58.5173 46.6856 58.1897 46.3476C57.857 46.007 57.7868 45.4948 58.1196 45.1386C58.5095 44.7226 58.9358 44.3196 59.4141 44.018C61.2052 42.887 63.2068 42.5776 65.2838 42.6868C66.2613 42.7388 67.2335 42.8922 68.2681 43.004C68.2265 41.2126 68.7594 39.5824 70.0488 38.2356C63.3524 35.4614 55.9906 37.4114 50.9891 43.7086C52.3564 44.5952 53.5262 45.6924 54.5192 46.9794C55.949 48.8332 57.0122 50.8794 57.7374 53.1024C57.9584 53.7758 57.74 54.2776 57.1759 54.4674C56.6326 54.652 56.1569 54.3634 55.9256 53.6848C55.0625 51.1628 53.7914 48.8878 51.9535 46.9326C47.0404 41.7118 38.7843 43.9946 35.943 49.2362C34.061 52.7098 33.5827 56.3732 34.061 60.2237C34.8148 66.2817 37.5106 71.3153 42.0753 75.3531C44.641 77.6255 47.6747 79.0893 50.8097 80.3711C53.0141 81.2733 55.2757 81.9675 57.6828 82.0741C60.9296 82.2171 63.472 80.9977 65.1643 78.1923C65.679 77.3395 66.0741 76.4139 66.4926 75.5065C66.8072 74.8253 67.2699 74.5393 67.8184 74.7603C68.3851 74.9891 68.5488 75.4987 68.2681 76.2111C67.4648 78.2495 66.4276 80.1423 64.7665 81.6243C62.8065 83.3741 60.4721 84.0501 57.8908 83.9851C54.813 83.9071 51.9587 82.9451 49.1642 81.7569C45.4469 80.1761 41.9817 78.2053 39.1768 75.2309C34.2508 70.0075 31.8488 63.7883 32.0074 56.5968C32.0672 53.9474 32.7196 51.4306 33.8868 49.0464C34.0116 48.7942 34.0792 48.4848 34.074 48.204C33.9986 44.499 35.4335 41.5324 38.4178 39.3458C39.611 38.4722 40.1517 37.2424 40.2998 35.8826C40.487 34.1562 40.5494 32.4064 40.513 30.6696C40.4818 29.094 40.9289 28.3296 42.5016 27.7134C44.9634 26.7488 47.4693 26.7774 49.9441 27.7082C50.4172 27.8876 50.8591 28.1996 51.2542 28.522C51.7377 28.9146 51.9249 29.4684 51.9223 30.1054C51.9145 33.4828 52.0211 36.8628 51.4596 40.2246ZM42.5484 32.279C42.4392 33.5738 42.4366 34.866 42.1897 36.1088C41.9817 37.1618 41.6022 38.22 41.0901 39.1638C40.7184 39.8502 40.0711 40.4326 39.4368 40.9188C37.8641 42.1252 36.7983 43.628 36.294 45.6144C40.0321 42.3202 44.2225 41.3348 48.9822 42.6738C49.8869 39.2678 50.1598 35.7864 49.9909 32.2478C46.4139 33.0174 46.4139 33.0174 42.5484 32.279ZM42.4678 29.9806C43.7312 31.2962 48.8185 31.2754 49.9623 29.9676C48.9354 28.6338 43.648 28.561 42.4678 29.9806ZM72.6457 40.4092C72.6275 40.1752 72.6327 39.9516 72.5885 39.7358C72.4611 39.1326 72.1102 38.9818 71.6475 39.3848C70.5453 40.3494 70.054 41.587 70.2567 43.0456C70.3607 43.7996 70.7246 43.914 71.3017 43.3966C72.1908 42.6036 72.5781 41.5688 72.6457 40.4092Z"
                fill="white" stroke="white"/>
              <path
                d="M75.1626 50.9577C76.3844 52.4267 77.5698 53.8489 78.7552 55.2737C78.8981 55.4453 79.0437 55.6117 79.1815 55.7885C79.678 56.4281 79.574 57.0079 78.8539 57.4005C77.3904 58.1987 75.9165 58.9761 74.4452 59.7613C71.2737 61.4513 68.1075 63.1517 64.9205 64.8131C64.6164 64.9717 64.151 65.0133 63.8339 64.9015C63.5999 64.8183 63.3998 64.4101 63.3478 64.1163C63.275 63.6977 63.561 63.4065 63.9405 63.2063C66.0201 62.1065 68.0945 60.9937 70.1689 59.8861C72.2772 58.7603 74.3854 57.6371 76.4936 56.5113C76.6547 56.4255 76.8107 56.3293 77.0083 56.2149C76.8965 56.0615 76.8133 55.9263 76.7119 55.8067C75.5629 54.4235 74.4088 53.0429 73.2598 51.6571C72.6281 50.8979 72.6775 50.4403 73.4599 49.8527C77.1227 47.102 80.788 44.3564 84.4481 41.6056C84.8562 41.2988 85.267 41.161 85.7219 41.4704C86.0884 41.72 86.2236 42.1048 86.0728 42.4948C85.9662 42.7652 85.7271 43.0174 85.4879 43.1968C82.2749 45.6174 79.0515 48.0302 75.8333 50.4429C75.6279 50.5989 75.4226 50.7601 75.1626 50.9577Z"
                fill="white" stroke="white"/>
              <path
                d="M76.9404 68.4272C76.7948 70.0314 76.6545 71.5602 76.5141 73.0916C76.5063 73.1852 76.5063 73.2762 76.4985 73.3698C76.4101 74.3734 75.9162 74.714 74.9622 74.4228C73.1893 73.8846 71.419 73.3438 69.6462 72.803C67.2026 72.0594 64.7565 71.3132 62.3103 70.5748C61.8346 70.4318 61.5174 70.1458 61.5044 69.6362C61.4915 69.2072 61.7124 68.8562 62.1283 68.7496C62.3935 68.6794 62.7184 68.7184 62.9888 68.799C66.5891 69.8806 70.1869 70.9752 73.7846 72.0672C74.0627 72.1504 74.3409 72.231 74.6762 72.3298C74.7724 71.2898 74.8634 70.3148 74.9544 69.3398C75.0194 68.656 75.0636 67.9722 75.1545 67.291C75.2429 66.6228 75.651 66.3212 76.3217 66.4174C80.2314 66.9712 84.1385 67.538 88.0482 68.0918C88.5187 68.1594 88.867 68.357 88.9736 68.8354C89.127 69.5218 88.5889 70.0886 87.8714 69.9898C85.7606 69.6934 83.6524 69.3788 81.5416 69.0772C80.039 68.8614 78.5339 68.6508 76.9404 68.4272Z"
                fill="white" stroke="white"/>
              <path
                d="M54.9251 58.438C55.2318 58.6642 55.588 58.802 55.7153 59.0542C55.8453 59.309 55.7855 59.6834 55.7335 59.9902C55.7075 60.1462 55.5152 60.2788 55.3904 60.4166C51.946 64.1892 51.9564 69.7298 55.4008 73.5024C55.6243 73.7468 55.8687 74.116 55.8427 74.402C55.8141 74.7036 55.5282 75.065 55.2526 75.2366C54.8679 75.4758 54.4728 75.273 54.1634 74.9506C52.8819 73.6194 51.9278 72.0828 51.4261 70.3018C50.2381 66.0716 51.1324 62.3146 54.075 59.0542C54.283 58.8202 54.5923 58.6746 54.9251 58.438Z"
                fill="white" stroke="white"/>
              <path
                d="M35.824 56.1943C36.1437 53.1783 36.934 50.5211 38.985 48.3839C39.8324 47.4999 40.8411 46.8577 41.9978 46.4599C42.5463 46.2727 43.0377 46.4989 43.2326 46.9955C43.4276 47.4921 43.2326 48.0069 42.6841 48.2149C40.173 49.1665 38.9226 51.1633 38.2311 53.5969C37.9842 54.4627 37.8932 55.3727 37.7554 56.2671C37.6852 56.7273 37.5839 57.1407 37.0925 57.3305C36.5025 57.5593 35.6238 57.1147 35.824 56.1943Z"
                fill="white" stroke="white"/>
              <path
                d="M54.7017 66.9195C54.7614 64.8603 55.4555 63.0533 56.9217 61.5739C57.3454 61.1475 57.8627 61.1345 58.263 61.5011C58.6581 61.8599 58.6815 62.3773 58.3176 62.8479C58.25 62.9363 58.1694 63.0143 58.0966 63.0975C56.5837 64.8785 56.2016 66.8831 57.0386 69.0567C57.2908 69.7145 57.7483 70.3073 58.1798 70.8767C58.6321 71.4773 58.6945 71.9999 58.2396 72.3977C57.8159 72.7695 57.2518 72.6941 56.7735 72.1793C55.4035 70.6999 54.7485 68.9345 54.7017 66.9195Z"
                fill="white" stroke="white"/>
              <defs>
                <filter id="filter0_d_602_17550" x="0.125977" y="0.125977" width="119.749" height="119.749"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                 result="hardAlpha"/>
                  <feOffset dy="5"/>
                  <feGaussianBlur stdDeviation="7.5"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_602_17550"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_602_17550" result="shape"/>
                </filter>
              </defs>
            </svg>
          </div>
          <div class="section-7__text desc">Лікування<br> життєзагрозливих<br> аритмій</div>
          <div class="section-7__text mob">Лікування життєзагрозливих аритмій</div>
        </li>
      </ul>
      <div class="section-7__middle">
        <div class="section-7__text">
          <strong>ІКД не виліковує аритмію і не попереджає її напади — </strong>
          він діє у разі настання епізоду раптової серцевої смерті.
        </div>
        <div class="section-7__text">
          <strong>Його завдання — </strong>
          контролювати ритм та зняти напад при виникненні загрози.
        </div>
      </div>
      <div class="section-7__bottom">
        <div class="section-7__bottom--content">
          <div class="section-7__bottom--text">Таким чином, пацієнт з ІКД має змогу повернутися до звичного ритму життя
            — працює, подорожує, спілкується, маючи в грудях
          </div>
          <div class="section-7__bottom--descr">«бригаду швидкої допомоги» в режимі</div>
          <div class="section-7__bottom--num">24/7</div>
          <div class="section-7__bottom--text">та впевненість у власному серці<sup>1</sup>.</div>
        </div>
        <div class="section-7__bottom--wrapper">
          <img class="section-7__bottom--img" src="@/assets/img/implantation/patient.png">
          <div class="rings"></div>
          <div class="rings"></div>
          <div class="rings"></div>
          <svg width="123" height="124" viewBox="0 0 123 124" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_605_17552)">
              <circle cx="61.5808" cy="52.0003" r="41.2903" fill="#FB35A2"/>
            </g>
            <g clip-path="url(#clip0_605_17552)">
              <path
                d="M70.6502 63.4011C70.449 63.4011 70.2574 63.4011 70.0669 63.4011C65.1079 63.4011 60.149 63.4011 55.19 63.4011C55.0113 63.4011 54.8325 63.4109 54.6548 63.3934C54.1678 63.3451 53.8713 63.0128 53.8681 62.527C53.8649 62.0412 54.1635 61.699 54.6441 61.6519C54.8207 61.6343 55.0006 61.6453 55.1793 61.6453C60.6017 61.6453 66.0252 61.6497 71.4477 61.631C71.7334 61.6299 72.0749 61.5005 72.2954 61.313C74.5132 59.4311 77.7082 59.4037 79.9292 61.3009C80.2267 61.5543 80.5114 61.6563 80.8893 61.6519C82.421 61.6343 83.9526 61.6453 85.556 61.6453C85.556 61.1639 85.556 60.7142 85.556 60.2646C85.556 58.9299 85.5678 57.5964 85.5443 56.2617C85.54 56.038 85.4308 55.765 85.2799 55.6027C84.4407 54.7056 83.5545 53.8546 82.726 52.9476C82.4349 52.6274 82.1769 52.2205 82.0506 51.806C81.2361 49.1235 80.4622 46.4279 79.6723 43.7378C79.5952 43.4757 79.5117 43.2147 79.4058 42.9646C79.2366 42.5666 78.9691 42.3373 78.5013 42.3395C75.2367 42.3516 71.9721 42.3461 68.7086 42.3472C68.639 42.3472 68.5705 42.3593 68.4325 42.3735C68.4325 42.5918 68.4325 42.8034 68.4325 43.0151C68.4325 48.2056 68.4325 53.3962 68.4325 58.5867C68.4325 58.7698 68.4464 58.9552 68.4207 59.1339C68.3511 59.6187 68.0653 59.8764 67.588 59.8917C67.1149 59.9071 66.7756 59.5967 66.7263 59.1054C66.7081 58.9245 66.7188 58.7402 66.7188 58.5571C66.7188 51.8499 66.7188 45.1426 66.7188 38.4343C66.7188 37.2784 66.5219 37.0799 65.3734 37.0799C56.544 37.0799 47.7136 37.0799 38.8842 37.0799C37.8213 37.0799 37.6083 37.2993 37.6083 38.3959C37.6083 45.9256 37.6083 53.4554 37.6083 60.9862C37.6083 61.1836 37.6083 61.3821 37.6083 61.6442C37.9969 61.6442 38.348 61.6442 38.699 61.6442C39.4301 61.6442 40.1633 61.6135 40.8933 61.6508C42.0086 61.7089 42.9526 61.4929 43.9588 60.8217C47.2876 58.6031 51.7542 60.4828 52.7999 64.4144C52.8599 64.6414 52.908 64.8706 52.9733 65.1524C53.1852 65.1524 53.395 65.1524 53.6059 65.1524C58.1367 65.1524 62.6675 65.1524 67.1983 65.1524C67.3589 65.1524 67.5216 65.1393 67.68 65.1601C68.1542 65.2226 68.4132 65.5078 68.4367 65.9969C68.4603 66.4827 68.1638 66.838 67.6886 66.8972C67.513 66.9192 67.3321 66.9082 67.1545 66.9082C62.6418 66.9082 58.1281 66.9082 53.6155 66.9082C53.4047 66.9082 53.1938 66.9082 52.9969 66.9082C52.0025 70.4099 49.8703 72.2292 46.8787 72.1689C44.6513 72.124 41.8138 70.6336 41.0752 66.9082C40.9147 66.9082 40.7402 66.9082 40.5668 66.9082C39.3712 66.9082 38.1767 66.9115 36.9811 66.9071C36.204 66.9038 35.8979 66.6022 35.8979 65.8247C35.8894 56.5611 35.8872 47.2943 35.8926 38.0285C35.8936 36.4636 37.0047 35.3274 38.531 35.3274C47.6108 35.322 56.6896 35.3231 65.7694 35.3274C67.3246 35.3285 68.4175 36.4614 68.4303 38.0636C68.4367 38.8828 68.4314 39.7021 68.4314 40.5893C69.0319 40.5893 69.5959 40.5893 70.16 40.5893C70.708 40.5893 71.2561 40.5893 71.8694 40.5893C71.7752 39.4663 71.8983 38.4519 72.7706 37.7072C73.2694 37.2817 73.8431 37.0657 74.495 37.081C76.0491 37.1172 76.7855 38.1152 77.0381 40.5893C77.5219 40.5893 78.0164 40.6046 78.5088 40.586C79.6669 40.5432 80.4997 41.1003 80.9085 42.1564C81.3859 43.3912 81.7338 44.6787 82.1159 45.9509C82.6233 47.6419 83.0985 49.344 83.6165 51.0317C83.7129 51.3454 83.9013 51.6579 84.1239 51.8959C85.0134 52.8456 85.9542 53.7438 86.8255 54.7089C87.0642 54.9732 87.2483 55.4042 87.2515 55.7606C87.2836 59.1054 87.2718 62.4492 87.2686 65.794C87.2675 66.6077 86.9689 66.9071 86.1618 66.9093C84.8089 66.9126 83.456 66.9104 82.0774 66.9104C81.7092 68.8954 80.7298 70.423 79.0226 71.4002C77.6044 72.2117 76.0877 72.4003 74.5249 71.9375C72.7674 71.4177 71.4883 70.2892 70.6995 68.5971C70.0326 67.1681 70.0316 66.1702 70.6502 63.4011ZM76.1112 70.4165C78.4788 70.4285 80.4033 68.4797 80.4151 66.0561C80.4269 63.6248 78.5291 61.6574 76.1626 61.6475C73.7907 61.6376 71.8662 63.5842 71.8576 66.0046C71.848 68.4304 73.7511 70.4044 76.1112 70.4165ZM42.7428 66.032C42.745 68.4556 44.6588 70.4176 47.0232 70.4176C49.3887 70.4176 51.3003 68.4567 51.3014 66.0298C51.3014 63.6018 49.3919 61.6475 47.0211 61.6486C44.6502 61.6486 42.7418 63.605 42.7428 66.032ZM37.6287 65.1261C38.805 65.1261 39.9364 65.1261 41.0538 65.1261C41.2219 64.5449 41.3814 63.9944 41.5451 63.4307C40.2329 63.4307 38.9431 63.4307 37.6287 63.4307C37.6287 63.9987 37.6287 64.5383 37.6287 65.1261ZM82.102 65.1272C83.2408 65.1272 84.3722 65.1272 85.5218 65.1272C85.5218 64.5471 85.5218 63.9944 85.5218 63.4318C84.202 63.4318 82.9144 63.4318 81.6086 63.4318C81.7745 64.0009 81.9307 64.5383 82.102 65.1272ZM75.2678 40.5629C75.2453 39.9795 75.4754 39.3402 74.8803 39.0002C74.6384 38.862 74.1888 38.8686 73.9502 39.0122C73.3668 39.3643 73.6055 39.9949 73.5841 40.5629C74.1482 40.5629 74.6748 40.5629 75.2678 40.5629Z"
                fill="white"/>
              <path
                d="M49.59 46.729C49.59 45.8648 49.5847 45.0653 49.5911 44.2647C49.5975 43.5409 49.9004 43.2262 50.5983 43.2218C51.6333 43.2152 52.6673 43.2163 53.7023 43.2218C54.4259 43.2262 54.7235 43.5409 54.7288 44.3042C54.7342 45.0883 54.7299 45.8714 54.7299 46.7301C55.5187 46.7301 56.2787 46.7279 57.0376 46.7301C57.8757 46.7323 58.1529 47.0185 58.155 47.8838C58.1572 48.9069 58.1604 49.9301 58.1539 50.9544C58.1486 51.6695 57.8371 51.9864 57.1371 51.9941C56.3557 52.0017 55.5744 51.9963 54.7299 51.9963C54.7299 52.8166 54.732 53.5963 54.7288 54.376C54.7256 55.2018 54.4366 55.5023 53.6381 55.5056C52.6395 55.5089 51.6408 55.5111 50.6411 55.5056C49.9004 55.5012 49.5964 55.1941 49.5911 54.4473C49.5847 53.6478 49.59 52.8495 49.59 51.9974C48.7937 51.9974 48.0487 51.9995 47.3048 51.9974C46.4389 51.9941 46.167 51.71 46.1649 50.8075C46.1627 49.8018 46.1606 48.7973 46.166 47.7916C46.1702 47.0404 46.4721 46.7366 47.2117 46.7323C47.9781 46.7257 48.7444 46.729 49.59 46.729ZM56.4285 48.4858C55.8559 48.4858 55.3261 48.4858 54.7952 48.4858C53.0655 48.4858 53.0162 48.4365 53.0162 46.6884C53.0162 46.1291 53.0162 45.5698 53.0162 45.0204C52.4051 45.0204 51.8645 45.0204 51.3058 45.0204C51.3058 45.8308 51.309 46.5974 51.3047 47.3639C51.3005 48.1842 51.0093 48.4814 50.2044 48.4847C49.4434 48.4891 48.6824 48.4858 47.9192 48.4858C47.9192 49.1032 47.9192 49.6571 47.9192 50.2383C48.7048 50.2383 49.452 50.2361 50.1991 50.2394C51.0072 50.2427 51.3005 50.5366 51.3047 51.3525C51.309 52.1333 51.3058 52.9142 51.3058 53.7147C51.8977 53.7147 52.4382 53.7147 53.0162 53.7147C53.0162 52.9164 53.0141 52.152 53.0173 51.3876C53.0205 50.5278 53.2999 50.2427 54.1412 50.2394C54.9001 50.2372 55.6589 50.2394 56.4285 50.2394C56.4285 49.6307 56.4285 49.1032 56.4285 48.4858Z"
                fill="white"/>
              <path
                d="M75.1727 52.8693C73.853 52.8693 72.5332 52.8726 71.2135 52.8682C70.4439 52.866 70.1442 52.5611 70.1421 51.7748C70.1388 49.5815 70.1388 47.3892 70.1421 45.1959C70.1431 44.4008 70.4343 44.096 71.2017 44.0949C73.199 44.0905 75.1963 44.0992 77.1946 44.0894C77.7362 44.0872 78.0616 44.323 78.2168 44.8548C78.8676 47.092 79.5344 49.3249 80.1799 51.5643C80.4164 52.3857 80.0407 52.8649 79.1866 52.8682C77.8486 52.8726 76.5107 52.8693 75.1727 52.8693ZM78.2457 51.0861C77.7448 49.3775 77.2674 47.7182 76.7579 46.0689C76.7237 45.957 76.4572 45.8627 76.2966 45.8594C75.2808 45.8408 74.264 45.8495 73.2472 45.8495C72.7923 45.8495 72.3363 45.8495 71.8846 45.8495C71.8846 47.6404 71.8846 49.3501 71.8846 51.085C73.9943 51.0861 76.074 51.0861 78.2457 51.0861Z"
                fill="white"/>
              <path
                d="M75.2752 33.602C75.2752 33.9113 75.2945 34.2217 75.271 34.5287C75.2324 35.0474 74.8824 35.3534 74.3847 35.3359C73.9148 35.3194 73.5916 35.0113 73.5744 34.5079C73.553 33.8905 73.552 33.2719 73.5755 32.6545C73.5948 32.1347 73.9501 31.8123 74.4371 31.8145C74.9231 31.8167 75.2442 32.1358 75.2742 32.6764C75.2913 32.9846 75.2774 33.2939 75.2774 33.6031C75.2774 33.602 75.2763 33.602 75.2752 33.602Z"
                fill="white"/>
              <path
                d="M70.3195 33C70.4191 33.0713 70.7038 33.1831 70.8461 33.3948C71.1865 33.9037 71.4766 34.4509 71.7549 35.0003C71.9957 35.4752 71.848 35.9248 71.4166 36.1705C71.0003 36.4073 70.57 36.3207 70.3003 35.8864C69.9674 35.3491 69.6516 34.7963 69.3765 34.2261C69.0886 33.6262 69.4846 33.0219 70.3195 33Z"
                fill="white"/>
              <path
                d="M71.8308 56.3765C71.529 56.3765 71.2261 56.3962 70.9264 56.3721C70.418 56.3315 70.1193 55.9762 70.1354 55.4673C70.1504 54.9848 70.4501 54.6514 70.9403 54.6339C71.5429 54.613 72.1466 54.6108 72.7481 54.636C73.2276 54.6558 73.5423 55.0122 73.553 55.4816C73.5637 55.9433 73.2544 56.3238 72.7877 56.3688C72.472 56.3995 72.1498 56.3743 71.8308 56.3743C71.8308 56.3743 71.8308 56.3754 71.8308 56.3765Z"
                fill="white"/>
              <path
                d="M77.9811 36.2996C77.2105 36.2711 76.793 35.6307 77.0713 35.0538C77.3539 34.4682 77.6803 33.9012 78.0282 33.3529C78.2926 32.9372 78.7015 32.8934 79.1093 33.1204C79.5214 33.3496 79.7023 33.7312 79.4871 34.1765C79.196 34.7786 78.8684 35.3653 78.5045 35.9246C78.3739 36.1242 78.0935 36.2218 77.9811 36.2996Z"
                fill="white"/>
              <path
                d="M76.1465 68.6639C74.7347 68.6683 73.5605 67.462 73.5669 66.0133C73.5723 64.5887 74.7315 63.4054 76.1261 63.3999C77.5444 63.3944 78.7132 64.5942 78.7046 66.0473C78.6961 67.4741 77.5369 68.6596 76.1465 68.6639ZM76.1379 65.1601C75.6659 65.1601 75.2923 65.5351 75.2848 66.0155C75.2774 66.5156 75.6755 66.9191 76.1625 66.9049C76.6281 66.8917 76.9931 66.498 76.9878 66.0177C76.9814 65.534 76.6099 65.159 76.1379 65.1601Z"
                fill="white"/>
              <path
                d="M46.9514 68.6625C45.5461 68.6274 44.4115 67.3849 44.4543 65.9296C44.496 64.5127 45.6895 63.3678 47.0917 63.3996C48.5002 63.4314 49.638 64.675 49.5888 66.1281C49.5396 67.5494 48.344 68.6987 46.9514 68.6625ZM47.8719 66.0162C47.8655 65.5337 47.493 65.1586 47.021 65.1597C46.5479 65.1608 46.1765 65.5359 46.1701 66.0162C46.1637 66.5174 46.5608 66.9188 47.0478 66.9045C47.5123 66.8903 47.8784 66.4955 47.8719 66.0162Z"
                fill="white"/>
            </g>
            <defs>
              <filter id="filter0_d_605_17552" x="0.290527" y="0.709961" width="122.581" height="122.581"
                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                               result="hardAlpha"/>
                <feOffset dy="10"/>
                <feGaussianBlur stdDeviation="10"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_605_17552"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_605_17552" result="shape"/>
              </filter>
              <clipPath id="clip0_605_17552">
                <rect width="51.3835" height="40.3728" fill="white" transform="translate(35.8892 31.8135)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </section>
    <section class="section-8 anchor" id="indication">
      <h2 class="section-8__title">Покази до імплантації ІКД </h2>
      <div class="section-8__description">Імплантація кардіовертера-дефібрилятора показана як для первинної так і
        вторинної профілактики РСС<sup>3,4</sup>.
      </div>
      <div class="section-8__subtitle">Вона рекомендована пацієнтам, які отримують оптимальну медикаментозну терапію, з
        очікуваною тривалістю життя більше одного року та:
      </div>
      <ul class="section-8__list">
        <li class="section-8__item">
          <div class="section-8__item--wrapper">
            <div class="section-8__item--num">1</div>
          </div>
          <div class="section-8__item--text"><strong>Перенесеною зупинкою кровообігу внаслідок фібриляції шлуночків
            (ФШ), або гемодинамічно нестабільної шлуночкової тахікардії (ШТ), </strong> за умови відсутності зворотніх
            причин, які могли призвести до РСС. Клас рекомендацій I, рівень доказовості А
          </div>
        </li>
        <li class="section-8__item">
          <div class="section-8__item--wrapper">
            <div class="section-8__item--num">2</div>
          </div>
          <div class="section-8__item--text"><strong>Ішемічною хворобою серця (ІХС).</strong><br>Пацієнти з <strong>ФВЛШ≤35%</strong>
            через 40 днів після інфаркта міокарда, або ≥90 днів після реваскуляризації і серцевою недостатністю <strong>II-III
              ФК за NYHA.</strong> Клас рекомендацій І, рівень доказовості А
          </div>
        </li>
        <li class="section-8__item">
          <div class="section-8__item--wrapper">
            <div class="section-8__item--num">3</div>
          </div>
          <div class="section-8__item--text"><strong>ІХС. </strong>Пацієнти з <strong>ФВЛШ≤30%</strong> через 40 днів
            після інфаркта міокарда, або ≥90 днів після реваскуляризації і серцевою недостатністю <strong>I ФК за
              NYHA.</strong> Клас рекомендацій І, рівень доказовості А
          </div>
        </li>
        <li class="section-8__item">
          <div class="section-8__item--wrapper">
            <div class="section-8__item--num">4</div>
          </div>
          <div class="section-8__item--text"><strong>Неішемічними кардіоміопатіями,</strong> з ФВЛШ ≤35% і серцевою
            недостатністю ІІ або ІІІ ФК за NYHA. Клас рекомендацій I, рівень доказовості А
          </div>
        </li>
      </ul>
      <router-link to="/check" class="secondary-btn"
                   onclick="gtag('event', 'click', {'event_category': 'Оцінити необхідність ІКД'})">
        <div class="secondary-btn__text" @click="setRestart">
          Оцінити необхідність ІКД
        </div>
        <div class="after secondary-btn__decor">
          <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L8 8L1 15" stroke="#FB35A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </router-link>
      <!-- <div class="section-8__bottom">
        <div class="section-8__bottom--subtitle">
          <img class="warning" src="@/assets/img/implantation/warning.svg">
          Більше інформації про ведення пацієнтів із високим ризиком раптової серцевої смерті та ІКД:
        </div>
        <ul class="section-8__bottom--list">
          <li class="section-8__bottom--item">
            <p class="section-8__bottom--text">Всеукраїнський реєстр пацієнтів з життєвозагрозливими захворюваннями серця</p>
            <a href="https://scd.com.ua/" class="section-8__bottom--link" target="_blank">scd.com.ua</a>
          </li>
          <li class="section-8__bottom--item">
            <p class="section-8__bottom--text">Рекомендації Європейського товариства з кардіології</p>
            <a href="https://academic.oup.com/journals" class="section-8__bottom--link" target="_blank">academic.oup.com</a>
          </li>
          <li class="section-8__bottom--item">
            <p class="section-8__bottom--text">Рекомендації Американського коледжу <nobr>кардіології/Американської</nobr> асоціації серця</p>
            <a href="https://www.jacc.org/" class="section-8__bottom--link" target="_blank">www.jacc.org</a>
            <a href="https://www.ahajournals.org/" class="section-8__bottom--link" target="_blank">www.ahajournals.org</a>
          </li>
          <li class="section-8__bottom--item">
            <p class="section-8__bottom--text">Всеукраїнська громадська організація «Асоціація аритмологів України»</p>
            <a href="https://asar.org.ua/" class="section-8__bottom--link" target="_blank">asar.org.ua</a>
          </li>
        </ul>
      </div> -->
    </section>
    <section class="section-9 anchor" id="conditions">
      <div class="section-9__top">
        <h2 class="section-9__title">Як пацієнтові безоплатно отримати кардіовертер-дефібрилятор?</h2>
        <div class="section-9__description">
          <img src="@/assets/img/implantation/wallet.png"/>
          <div class="section-9__text">В Україні за кошти Державного бюджету України на 2019 рік за бюджетною програмою
            КПКВК 2301400 «Забезпечення медичних заходів окремих державних програм та комплексних заходів програмного
            характеру» за напрямом «Закупівля лікарських засобів, імунобіологічних препаратів, медичних виробів, інших
            товарів і послуг» у частині «Закупівля лікарських засобів та медичних виробів для закладів охорони здоров'я
            для забезпечення лікуванням хворих із серцево-судинними та судинно-мозковими захворюваннями» <strong>є
              можливість закуповувати кардіовертери-дефібрилятори за кошти Державного бюджету
              України<sup>5</sup>.</strong></div>
        </div>
      </div>
      <div class="section-9__bottom">
        <div class="left">
          <div class="section-9__subtitle">Алгоритм безоплатного отримання кардіовертера-дефібрилятора:</div>
          <ul class="section-9__list">
            <li class="section-9__item">
              <div class="section-9__item--wrapper">
                <div class="section-9__item--container">
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_621_17547)">
                      <circle cx="55.9998" cy="50.9998" r="40.8172" fill="#FB35A2"/>
                    </g>
                    <g clip-path="url(#clip0_621_17547)">
                      <path
                        d="M36.432 51.5384C36.432 47.4115 36.4235 43.2854 36.4338 39.1584C36.4479 33.8576 40.0608 29.4555 45.3446 28.3311C46.1295 28.1642 46.9509 28.0936 47.7555 28.0908C53.4303 28.0706 59.1052 28.0725 64.7809 28.0825C70.453 28.0926 75.0875 31.9848 75.9763 37.4765C76.0567 37.9726 76.0932 38.4807 76.0942 38.9833C76.1026 44.7757 76.1035 50.5681 76.0988 56.3615C76.0979 57.7583 74.9818 58.6222 73.6805 58.2581C72.934 58.049 72.4307 57.4364 72.3661 56.6495C72.3512 56.467 72.3577 56.2826 72.3577 56.0992C72.3577 50.4599 72.3624 44.8197 72.3549 39.1804C72.3502 35.5625 69.8889 32.6057 66.2871 31.8913C65.8025 31.795 65.2974 31.7583 64.8015 31.7574C59.1108 31.7482 53.42 31.7455 47.7293 31.7537C43.4932 31.7601 40.1853 34.9902 40.1806 39.1337C40.1712 47.4179 40.1712 55.7012 40.1806 63.9854C40.1853 68.1271 43.4932 71.3525 47.7293 71.3681C49.5535 71.3745 51.3778 71.3589 53.202 71.3727C54.5595 71.3828 55.4108 72.4815 55.0553 73.7297C54.8429 74.4762 54.2049 75.0237 53.3751 75.0246C51.0223 75.0264 48.6592 75.109 46.3194 74.9274C41.5998 74.5624 37.4096 70.6592 36.634 66.0608C36.5096 65.3262 36.4469 64.5733 36.4432 63.8286C36.4226 59.73 36.432 55.6342 36.432 51.5384Z"
                        fill="white"/>
                      <path
                        d="M65.4969 75.0298C64.1132 74.9941 62.7539 74.5704 61.6687 73.5175C60.1616 72.0557 58.6722 70.5755 57.2007 69.0797C56.1697 68.0314 56.6197 66.3843 58.0211 66.0119C58.7443 65.8193 59.3739 66.0202 59.8987 66.542C61.244 67.881 62.5893 69.2209 63.9355 70.5589C65.0254 71.642 66.1629 71.6411 67.2603 70.5553C70.3877 67.4619 73.5039 64.3575 76.652 61.2843C76.9953 60.9495 77.4921 60.6698 77.9617 60.5753C78.7326 60.4203 79.3537 60.8119 79.7635 61.464C80.1611 62.0977 80.1255 62.7443 79.7214 63.3652C79.6054 63.5431 79.4548 63.7036 79.3023 63.8549C76.1009 67.0272 72.8996 70.1994 69.6936 73.3671C68.5934 74.4539 67.177 75.0234 65.4969 75.0298Z"
                        fill="white"/>
                      <path
                        d="M56.2658 43.4056C54.7409 43.4056 53.2011 43.5404 51.6949 43.3772C48.5684 43.0406 46.122 40.17 46.1641 37.084C46.1781 36.0614 46.9593 35.2626 47.9725 35.2342C49.0081 35.2057 49.8416 35.9724 49.9043 37.0134C50.01 38.7687 51.1345 39.816 52.9213 39.8179C55.1488 39.8197 57.3772 39.8197 59.6047 39.8179C61.3915 39.816 62.5141 38.7733 62.6301 37.0152C62.7003 35.9449 63.4974 35.2103 64.5545 35.2406C65.6051 35.2718 66.3535 36.0495 66.3703 37.128C66.4162 40.1398 63.9502 43.0369 60.8845 43.3707C59.3633 43.5367 57.8076 43.3992 56.2668 43.3992C56.2658 43.4019 56.2658 43.4037 56.2658 43.4056Z"
                        fill="white"/>
                      <path
                        d="M60.4671 49.633C62.1651 49.6321 63.864 49.6211 65.5619 49.6367C66.9128 49.6486 67.7623 50.7565 67.403 52.001C67.185 52.7576 66.5246 53.2895 65.6704 53.2932C62.181 53.3088 58.6905 53.3116 55.2011 53.2932C54.1364 53.2877 53.3768 52.4907 53.3731 51.4746C53.3693 50.4392 54.1411 49.6514 55.2329 49.6395C56.9767 49.6193 58.7214 49.634 60.4671 49.633Z"
                        fill="white"/>
                      <path
                        d="M60.4224 60.6387C58.7085 60.6387 56.9946 60.6515 55.2808 60.6341C53.9215 60.6204 53.0645 59.4556 53.4687 58.213C53.7203 57.438 54.4042 56.9739 55.3388 56.9712C57.5662 56.9648 59.7946 56.9694 62.0221 56.9694C63.1747 56.9694 64.3282 56.9648 65.4807 56.9712C66.6782 56.9776 67.4893 57.7278 67.4855 58.81C67.4818 59.8931 66.6716 60.6341 65.4695 60.6387C63.7874 60.6433 62.1044 60.6387 60.4224 60.6387Z"
                        fill="white"/>
                      <path
                        d="M47.3784 48.9917C48.6517 48.9917 49.7125 50.017 49.7163 51.2496C49.72 52.562 48.6797 53.5827 47.3522 53.569C46.035 53.5552 45.0378 52.5537 45.0415 51.2487C45.0462 50.0115 46.1024 48.9908 47.3784 48.9917Z"
                        fill="white"/>
                      <path
                        d="M45.0425 58.5723C45.0519 57.337 46.1137 56.3217 47.3907 56.3282C48.663 56.3337 49.7201 57.3654 49.7164 58.598C49.7127 59.9122 48.6677 60.9265 47.3402 60.9054C46.023 60.8843 45.0332 59.8792 45.0425 58.5723Z"
                        fill="white"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_621_17547" x="0.182617" y="0.182617" width="111.634" height="111.634"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="5"/>
                        <feGaussianBlur stdDeviation="7.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_621_17547"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_621_17547" result="shape"/>
                      </filter>
                      <clipPath id="clip0_621_17547">
                        <rect width="43.6129" height="46.9677" fill="white" transform="translate(36.4302 28.0752)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="section-9__item--title mob">Крок 1</div>
              </div>
              <div class="section-9__item--content">
                <div class="section-9__item--title desc">Крок 1</div>
                <div class="section-9__item--text">
                  Спеціаліст надає пацієнту <strong>консультаційний висновок</strong> з діагнозом та рекомендаціями щодо
                  імплантації кардіовертера-дефібрилятора.
                </div>
              </div>
            </li>
            <li class="section-9__item">
              <div class="section-9__item--wrapper">
                <div class="section-9__item--container">
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_621_17548)">
                      <circle cx="55.9998" cy="50.9998" r="40.8172" fill="#FB35A2"/>
                    </g>
                    <path
                      d="M54.7581 53.2994C54.6378 53.3812 54.5138 53.4583 54.3972 53.5447C53.1012 54.5043 51.7987 55.4554 50.5149 56.4309C49.8157 56.9619 49.1456 56.976 48.389 56.5334C42.877 53.3135 37.3566 50.1068 31.8333 46.9048C31.1801 46.5261 30.7572 46.0298 30.8521 45.2441C30.9442 44.4857 31.4414 44.0985 32.1463 43.8682C46.9953 39.0244 61.8396 34.1701 76.6858 29.3187C77.7732 28.9635 78.6942 29.3789 78.8962 30.3666C78.9639 30.6975 78.9 31.0865 78.7938 31.4164C77.6247 35.0479 76.4368 38.6738 75.2517 42.2997C71.5995 53.4761 67.9474 64.6526 64.2953 75.829C64.2662 75.9183 64.2342 76.0067 64.207 76.0959C63.9984 76.7783 63.5482 77.1974 62.8358 77.2689C62.1394 77.3393 61.6375 77.0066 61.2917 76.4108C60.1367 74.4212 58.9779 72.4344 57.8219 70.4457C55.7694 66.9147 53.7337 63.3744 51.6539 59.8594C51.1352 58.9816 51.1624 58.2542 51.7921 57.4554C52.7507 56.2383 53.6501 54.9742 54.573 53.7289C54.6604 53.6105 54.7375 53.4846 54.8202 53.3624C54.7985 53.3408 54.7788 53.3201 54.7581 53.2994ZM36.211 45.8127C36.2993 45.8842 36.3435 45.9302 36.3961 45.9603C40.6017 48.4057 44.8093 50.8474 49.0093 53.3022C49.2771 53.4583 49.4294 53.3662 49.6277 53.2177C52.6163 50.9931 55.6068 48.7723 58.5973 46.5515C59.6151 45.7958 60.6226 45.0252 61.6535 44.2883C62.692 43.5459 64.0275 44.1248 64.16 45.3597C64.2136 45.8597 63.989 46.2639 63.7004 46.652C60.7757 50.5833 57.8595 54.5193 54.9282 58.4459C54.7196 58.726 54.7027 58.9187 54.8822 59.226C57.1979 63.1817 59.4967 67.1469 61.8011 71.1092C61.9496 71.3639 62.1018 71.6167 62.2945 71.9428C66.5246 58.9967 70.7302 46.1257 74.9706 33.1495C61.9909 37.389 49.1193 41.5948 36.211 45.8127Z"
                      fill="white"/>
                    <path
                      d="M35.7079 73.9327C35.1111 73.9158 34.6516 73.6508 34.3706 73.1263C34.0914 72.6047 34.1121 72.07 34.4241 71.5634C34.5209 71.4065 34.6572 71.2692 34.7888 71.1367C38.1195 67.8022 41.4558 64.4733 44.7818 61.1332C45.2517 60.6614 45.778 60.4246 46.4302 60.5834C47.4368 60.8277 47.9039 62.0288 47.3447 62.9095C47.2451 63.0664 47.1125 63.2046 46.98 63.3371C43.6493 66.6716 40.3149 70.0024 36.9851 73.3387C36.628 73.6968 36.2342 73.9487 35.7079 73.9327Z"
                      fill="white"/>
                    <path
                      d="M33.0615 62.2525C33.1555 62.073 33.2702 61.6586 33.5324 61.3879C34.8678 60.0035 36.2334 58.6483 37.6055 57.3006C38.222 56.6944 39.1609 56.7113 39.7624 57.2949C40.3704 57.8842 40.4287 58.8222 39.8225 59.4462C38.4495 60.8588 37.0529 62.2497 35.6422 63.6256C35.178 64.0786 34.5878 64.1576 33.9872 63.885C33.3886 63.6125 33.0916 63.1294 33.0615 62.2525Z"
                      fill="white"/>
                    <path
                      d="M51.3644 69.4764C51.1727 69.8364 51.0486 70.2612 50.777 70.5441C49.4651 71.9068 48.1183 73.2367 46.7725 74.5666C46.1297 75.2009 45.1889 75.2132 44.5809 74.6267C43.9408 74.0092 43.9117 73.0675 44.5621 72.405C45.9088 71.0319 47.2715 69.6748 48.6418 68.3252C49.1211 67.8534 49.7122 67.7462 50.3306 68.0178C50.9274 68.2791 51.2366 68.7603 51.3644 69.4764Z"
                      fill="white"/>
                    <defs>
                      <filter id="filter0_d_621_17548" x="0.182617" y="0.182617" width="111.634" height="111.635"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="5"/>
                        <feGaussianBlur stdDeviation="7.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_621_17548"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_621_17548" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div class="section-9__item--title mob">Крок 2</div>
              </div>
              <div class="section-9__item--content">
                <div class="section-9__item--title desc">Крок 2</div>
                <div class="section-9__item--text">
                  <strong>Лікарня від імені закладу,</strong> у якому консультувався пацієнт, <strong>надсилає офіційний
                  лист до Департаменту охорони здоров’я</strong> (за місцем прописки пацієнта) на ім’я його директора. У
                  разі виникнення питань та непорозумінь пацієнт має право звернутися безпосередньо до МОЗ України.
                </div>
              </div>
            </li>
            <li class="section-9__item">
              <div class="section-9__item--wrapper">
                <div class="section-9__item--container">
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <svg width="111" height="111" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_621_17549)">
                      <circle cx="55.4999" cy="50.4999" r="40.4247" fill="#FB35A2"/>
                    </g>
                    <path
                      d="M39.7295 46.2425C38.8325 46.2027 37.9909 46.233 37.1692 46.1171C34.8884 45.7952 33.155 43.948 32.8376 41.5825C32.5495 39.4377 33.7769 37.1838 35.832 36.3135C39.1707 34.8997 42.5389 33.556 45.8957 32.183C48.1861 31.2459 50.4817 30.3193 52.7669 29.3702C54.1647 28.7905 55.5581 28.7299 56.9663 29.3053C62.6274 31.6171 68.2928 33.9194 73.947 36.2486C75.9762 37.0843 77.1741 39.0484 77.0937 41.2659C77.0176 43.3329 75.5999 45.2458 73.588 45.9086C73.05 46.0859 72.4636 46.1448 71.8945 46.1932C71.34 46.2399 70.7787 46.2036 70.1784 46.2036C70.1784 46.4139 70.1784 46.5826 70.1784 46.7513C70.1784 50.572 70.1819 54.3928 70.1767 58.2144C70.1749 59.4931 69.0626 60.3385 67.9044 59.9569C67.1727 59.7164 66.7203 59.0675 66.7186 58.2317C66.7151 56.0116 66.7169 53.7906 66.7169 51.5705C66.7169 49.956 66.7169 48.3407 66.7169 46.7262C66.7169 46.5705 66.7169 46.4138 66.7169 46.2313C63.3669 46.2313 60.0472 46.2313 56.6851 46.2313C56.6851 46.4156 56.6851 46.5843 56.6851 46.753C56.6851 50.5599 56.6826 54.3659 56.6877 58.1728C56.6886 58.7378 56.5338 59.2319 56.1022 59.603C55.5512 60.0763 54.9206 60.1922 54.2503 59.8885C53.5834 59.5866 53.234 59.0458 53.2271 58.3173C53.2141 56.8465 53.2227 55.3756 53.2227 53.9057C53.2227 51.5125 53.2227 49.1185 53.2227 46.7253C53.2227 46.5696 53.2227 46.4138 53.2227 46.2313C49.8711 46.2313 46.5522 46.2313 43.191 46.2313C43.191 46.4173 43.191 46.586 43.191 46.7556C43.191 50.5625 43.1884 54.3685 43.1936 58.1754C43.1945 58.7404 43.0388 59.2345 42.6072 59.6048C42.0562 60.078 41.4248 60.1931 40.7553 59.8885C40.0893 59.5866 39.7399 59.045 39.733 58.3165C39.72 56.7885 39.7286 55.2597 39.7286 53.7318C39.7286 51.3957 39.7286 49.0605 39.7286 46.7245C39.7295 46.567 39.7295 46.4113 39.7295 46.2425ZM54.9552 42.7411C60.5325 42.7411 66.1097 42.7445 71.686 42.7315C72.0337 42.7307 72.4152 42.6658 72.7231 42.5126C73.358 42.1977 73.6676 41.6293 73.6252 40.9189C73.5776 40.11 73.1002 39.6229 72.3684 39.3252C66.8388 37.074 61.3126 34.8166 55.7873 32.5541C55.2208 32.3223 54.6871 32.324 54.1171 32.5585C50.7386 33.9488 47.3523 35.3228 43.9695 36.7037C41.7985 37.5896 39.6274 38.4765 37.4581 39.3668C36.428 39.7898 35.9851 40.8272 36.4487 41.7582C36.8008 42.4651 37.4028 42.7445 38.1804 42.7437C43.7723 42.7385 49.3633 42.7411 54.9552 42.7411Z"
                      fill="white"/>
                    <path
                      d="M54.9089 73.1973C49.2884 73.1973 43.6671 73.2033 38.0466 73.1947C35.0227 73.1904 32.6986 70.7522 32.8137 67.7335C32.9131 65.1457 35.1369 62.9195 37.7249 62.8183C37.8546 62.8131 37.9843 62.8131 38.1141 62.8131C49.3412 62.8131 60.5682 62.8113 71.7944 62.8139C74.4715 62.8148 76.62 64.63 77.03 67.2204C77.5187 70.3075 75.1193 73.1713 71.9865 73.1904C68.1097 73.2137 64.233 73.1964 60.3563 73.1973C58.5408 73.1981 56.7244 73.1973 54.9089 73.1973ZM54.959 69.7347C60.2465 69.7347 65.5348 69.7347 70.8222 69.7347C71.2115 69.7347 71.6007 69.7477 71.9891 69.7295C72.8462 69.6889 73.5451 69.0166 73.6273 68.1713C73.7086 67.3372 73.181 66.5655 72.3558 66.3492C72.1231 66.2886 71.8723 66.2782 71.6301 66.2782C60.5068 66.2748 49.3835 66.2756 38.2603 66.2756C38.1305 66.2756 38.0008 66.2713 37.871 66.2808C37.0364 66.3431 36.3548 67.011 36.2761 67.8382C36.1982 68.6575 36.7077 69.4267 37.5052 69.6491C37.7499 69.7174 38.0163 69.7304 38.2724 69.7313C43.8357 69.7365 49.3974 69.7347 54.959 69.7347Z"
                      fill="white"/>
                    <path
                      d="M54.9497 35.8213C55.9029 35.8196 56.6805 36.5948 56.6822 37.5482C56.6839 38.5008 55.9072 39.2804 54.9558 39.2812C54.0034 39.283 53.225 38.5069 53.2241 37.5534C53.2224 36.5991 53.9965 35.8222 54.9497 35.8213Z"
                      fill="white"/>
                    <defs>
                      <filter id="filter0_d_621_17549" x="0.0751953" y="0.0751953" width="110.85" height="110.85"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="5"/>
                        <feGaussianBlur stdDeviation="7.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_621_17549"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_621_17549" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div class="section-9__item--title mob">Крок 3</div>
              </div>
              <div class="section-9__item--content">
                <div class="section-9__item--title desc">Крок 3</div>
                <div class="section-9__item--text">
                  <strong>Обласний департамент охорони здоров’я</strong> (за місцем прописки пацієнта) <strong>видає
                  скерування на отримання медичних виробів або формує заявку</strong> в МОЗ України <strong>на
                  закупівлю</strong> кардіовертера-дефібрилятора в наступному бюджетному році.
                  <br><br>
                  У разі наявності кардіовертера-дефібрилятора в іншій області України департамент повідомляє про цю
                  ситуацію МОЗ України та департамент області, у якій є необхідний виріб. <strong>МОЗ України видає
                  наказ про перерозподіл виробів між департаментами.</strong>
                </div>
              </div>
            </li>
            <li class="section-9__item">
              <div class="section-9__item--wrapper">
                <div class="section-9__item--container">
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <div class="section-9__icon-wrapper icon-wrapper rings"></div>
                  <svg width="111" height="111" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_621_17550)">
                      <circle cx="55.4999" cy="50.4999" r="40.4247" fill="#FB35A2"/>
                    </g>
                    <path
                      d="M36.1207 34.5182C36.1207 34.2536 36.1267 33.985 36.1745 33.7263C36.2173 33.4945 36.3118 33.2855 36.4422 33.1055C36.272 33.3482 36.1695 33.6427 36.1575 33.97C36.1227 34.8774 36.7328 35.6295 37.6793 35.6534C38.1063 35.6644 38.6985 35.6723 39.3813 35.6783C39.3823 46.098 39.3813 60.3003 39.3813 70.3837C39.3813 70.5926 39.3813 70.8005 39.3813 71.0115C42.3871 71.0115 45.3162 71.0115 48.3021 71.0115C48.3021 70.8055 48.3021 70.6284 48.3021 70.4503C48.3021 68.4605 48.2981 66.4707 48.3041 64.4809C48.3071 63.2581 48.9152 62.6333 50.1324 62.6304C53.5334 62.6224 56.9333 62.6224 60.3342 62.6304C61.5475 62.6333 62.1615 63.2671 62.1635 64.4819C62.1675 66.4717 62.1645 68.4615 62.1645 70.4513C62.1645 70.6294 62.1645 70.8075 62.1645 70.9945C65.4689 70.9945 68.7205 70.9945 71.999 70.9945C71.999 70.7359 71.999 70.521 71.999 70.3071C71.999 60.2535 71.999 46.0273 71.999 35.6863C72.6549 35.6823 73.2431 35.6753 73.698 35.6674C74.5012 35.6524 75.0785 35.1769 75.2586 34.5023C75.2626 37.695 75.2616 65.817 75.2586 72.3665C75.2576 73.6967 74.6365 74.3086 73.3058 74.3096C69.8054 74.3106 66.3059 74.3096 62.8055 74.3096C60.0854 74.3096 57.9614 74.3056 55.2413 74.3126C54.663 74.3136 54.1534 74.1723 53.7842 73.7067C53.3801 73.1983 53.2825 72.6272 53.5523 72.0282C53.8479 71.3716 54.3903 71.0532 55.096 71.0453C56.3729 71.0304 57.0537 71.0403 58.3307 71.0403C58.5058 71.0403 58.682 71.0403 58.8602 71.0403C58.8602 69.2883 58.8602 67.6069 58.8602 65.9036C56.4277 65.9036 54.031 65.9036 51.5617 65.9036C51.5617 66.1235 51.5617 66.3165 51.5617 66.5095C51.5617 68.4993 51.5706 70.4891 51.5577 72.4789C51.5497 73.6878 50.9078 74.3086 49.6985 74.3086C45.7999 74.3116 41.9024 74.3106 38.0038 74.3076C37.7898 74.3076 37.5699 74.2996 37.3638 74.2479C36.5298 74.04 36.1207 73.4112 36.1197 72.3476C36.1177 65.7981 36.1177 37.5527 36.1207 34.5182Z"
                      fill="white"/>
                    <path
                      d="M50.55 25.1449C50.5461 25.0972 50.5431 25.0494 50.5431 25.0007C50.5431 24.539 50.7232 24.1401 51.0308 23.8516C50.7959 24.1003 50.6287 24.4336 50.56 24.8325C50.556 24.8514 50.553 24.9659 50.55 25.1449Z"
                      fill="white"/>
                    <path
                      d="M51.0298 23.8519C51.3433 23.5206 51.7812 23.3425 52.2769 23.3724C51.7683 23.3903 51.3353 23.5654 51.0298 23.8519Z"
                      fill="white"/>
                    <path
                      d="M53.8021 25.0704C53.8051 25.2644 53.8071 25.8842 53.8091 26.6423C53.3254 26.6423 52.8426 26.6413 52.3589 26.6383C51.3507 26.6324 50.6241 26.0135 50.5505 25.146C50.5535 24.9669 50.5564 24.8525 50.5594 24.8336C50.6281 24.4346 50.7953 24.1013 51.0302 23.8526C51.3358 23.5661 51.7687 23.391 52.2773 23.373C52.2913 23.374 52.3052 23.373 52.3201 23.375C53.1801 23.4467 53.7882 24.1361 53.8021 25.0704Z"
                      fill="white"/>
                    <path
                      d="M64.3946 33.9926C64.3598 34.885 65.0336 35.6451 65.9971 35.665C66.1404 35.668 66.2976 35.671 66.4648 35.673C66.4629 36.3236 66.4599 36.9743 66.4549 37.625C66.4479 38.6169 65.7791 39.2686 64.7868 39.2835C63.6591 39.3004 62.5314 39.2885 61.4038 39.2885C61.2276 39.2885 61.0524 39.2885 60.8952 39.2885C60.8683 39.387 60.8524 39.4188 60.8524 39.4496C60.8484 40.6097 60.8474 41.7708 60.8444 42.9308C60.8404 44.3147 60.2283 44.9256 58.8339 44.9266C56.7279 44.9286 54.6209 44.9286 52.5148 44.9256C52.3168 44.9256 52.1157 44.9157 51.9206 44.8848C51.2239 44.7754 50.7163 44.2889 50.5899 43.5914C50.5431 43.3328 50.5382 43.0641 50.5372 42.8005C50.5322 41.6454 50.5352 40.4903 50.5352 39.2895C50.3003 39.2895 50.1221 39.2895 49.943 39.2895C48.8153 39.2885 47.6877 39.3014 46.56 39.2835C45.6563 39.2696 44.9476 38.6577 44.9377 37.7971C44.9287 37.0907 44.9237 36.3843 44.9207 35.6779C45.6254 35.671 46.2365 35.662 46.6734 35.6501C47.5861 35.6252 48.2052 34.8601 48.1743 33.9936C48.1435 33.1011 47.4567 32.4365 46.5232 32.4226C46.2405 32.4186 45.6413 32.4166 44.9217 32.4156C44.9257 31.7729 44.9307 31.1292 44.9387 30.4865C44.9486 29.6617 45.6174 29.0529 46.4724 29.026C47.4995 28.9942 48.5287 29.0131 49.5568 29.0101C49.8673 29.0091 50.1769 29.0101 50.4964 29.0101C50.5193 28.8678 50.5352 26.094 50.5511 25.1468C50.6248 26.0144 51.3513 26.6332 52.3596 26.6392C52.8433 26.6422 53.326 26.6432 53.8097 26.6432C53.8117 28.1495 53.8097 30.2069 53.8017 30.593C53.7808 31.562 53.1508 32.2147 52.1854 32.2475C51.5066 32.2704 50.8258 32.2555 50.146 32.2565C49.5051 32.2575 48.8641 32.2565 48.1992 32.2565C48.1992 33.5429 48.1992 34.7606 48.1992 36.0182C48.4122 36.0182 48.5924 36.0182 48.7725 36.0182C49.8504 36.0182 50.9283 36.0112 52.0062 36.0202C53.1448 36.0301 53.7958 36.6838 53.8037 37.815C53.8097 38.6607 53.8047 39.5063 53.8047 40.351C53.8047 40.7759 53.8047 41.2007 53.8047 41.6355C55.0896 41.6355 56.3079 41.6355 57.5739 41.6355C57.5739 41.4444 57.5739 41.2833 57.5739 41.1211C57.5739 40.0267 57.5699 38.9323 57.5749 37.8389C57.5809 36.6748 58.2248 36.0301 59.3973 36.0182C60.1935 36.0102 60.9897 36.0162 61.786 36.0162C62.2438 36.0162 62.7016 36.0162 63.1664 36.0162C63.1664 34.7348 63.1664 33.518 63.1664 32.2594C62.9465 32.2594 62.7673 32.2594 62.5872 32.2594C61.4764 32.2584 60.3647 32.2754 59.2539 32.2525C58.2188 32.2306 57.5948 31.5809 57.5749 30.5552C57.5689 30.2408 57.5739 29.9254 57.5739 29.61C57.5739 28.637 57.5739 27.663 57.5739 26.6402C57.343 26.6402 57.1648 26.6402 56.9857 26.6402C55.9267 26.6402 54.8677 26.6432 53.8087 26.6422C53.8077 25.8841 53.8057 25.2642 53.8017 25.0702C53.7868 24.136 53.1787 23.4475 52.3197 23.3749C52.3048 23.3739 52.2909 23.3739 52.2769 23.3729C52.3028 23.3719 52.3287 23.3699 52.3556 23.3699C54.5781 23.365 56.8006 23.365 59.023 23.3699C60.1597 23.3729 60.8235 24.0166 60.8404 25.1498C60.8564 26.2442 60.8444 27.3386 60.8444 28.432C60.8444 28.6081 60.8444 28.7832 60.8444 29.0091C61.0923 29.0091 61.2704 29.0091 61.4496 29.0091C62.5603 29.0101 63.6721 28.9951 64.7828 29.016C65.798 29.0349 66.4469 29.6637 66.4539 30.6626C66.4579 31.2476 66.4619 31.8326 66.4638 32.4176C66.3424 32.4186 66.22 32.4186 66.0986 32.4196C65.1262 32.4306 64.4305 33.0812 64.3946 33.9926Z"
                      fill="white"/>
                    <path
                      d="M74.063 32.5061C73.0975 32.2236 72.1003 32.8952 72.0127 33.896C71.9928 34.1269 71.9997 34.3597 71.9997 34.5925C71.9997 34.9526 71.9997 35.3178 71.9997 35.6879C70.2092 35.6998 67.917 35.6958 66.4649 35.6739C66.4679 34.5885 66.4679 33.504 66.4639 32.4186C67.2363 32.4136 68.0076 32.4186 68.78 32.4186C69.6568 32.4186 72.7243 32.4116 73.6012 32.4206C74.5855 32.4295 75.2842 33.0673 75.317 33.9716C75.324 34.1587 75.3031 34.3378 75.2583 34.5049C75.2583 34.4512 75.2583 34.3985 75.2583 34.3477C75.2573 33.3339 74.8632 32.74 74.063 32.5061Z"
                      fill="white"/>
                    <path
                      d="M73.6987 35.6672C73.2448 35.6761 72.6556 35.6821 71.9997 35.6861C71.9997 35.316 71.9997 34.9508 71.9997 34.5907C71.9997 34.3588 71.9917 34.125 72.0126 33.8942C72.1012 32.8943 73.0975 32.2218 74.063 32.5043C74.8632 32.7381 75.2573 33.3321 75.2583 34.3439C75.2583 34.3947 75.2583 34.4474 75.2583 34.5011C75.0782 35.1767 74.5019 35.6522 73.6987 35.6672Z"
                      fill="white"/>
                    <path
                      d="M66.4652 35.6723C66.2979 35.6693 66.1407 35.6673 65.9974 35.6644C65.0339 35.6445 64.3601 34.8843 64.3949 33.9919C64.4308 33.0806 65.1265 32.4299 66.0989 32.42C66.2203 32.419 66.3427 32.418 66.4642 32.418C66.4681 33.5024 66.4681 34.5869 66.4652 35.6723Z"
                      fill="white"/>
                    <path
                      d="M44.9199 35.6765C43.2458 35.6924 41.0442 35.6924 39.3811 35.6785C39.3811 35.2358 39.3811 34.798 39.3811 34.3692C39.3811 33.3236 38.9929 32.7286 38.1718 32.4988C37.5119 32.3147 36.8222 32.5834 36.443 33.1057C36.7346 32.6908 37.2283 32.4282 37.8255 32.4212C38.7192 32.4092 39.613 32.4182 40.5068 32.4192C41.1348 32.4192 43.3235 32.4142 44.9209 32.4152C44.9149 33.5017 44.9149 34.5891 44.9199 35.6765Z"
                      fill="white"/>
                    <path
                      d="M38.1716 32.4978C38.9927 32.7276 39.3809 33.3225 39.3809 34.3682C39.3809 34.797 39.3809 35.2338 39.3809 35.6775C38.6981 35.6715 38.1049 35.6636 37.6789 35.6526C36.7324 35.6287 36.1223 34.8766 36.1571 33.9692C36.1701 33.6419 36.2716 33.3474 36.4418 33.1047C36.822 32.5823 37.5117 32.3127 38.1716 32.4978Z"
                      fill="white"/>
                    <path
                      d="M48.1747 33.991C48.2055 34.8586 47.5865 35.6227 46.6738 35.6475C46.2368 35.6595 45.6247 35.6684 44.9211 35.6754C44.9161 34.588 44.9161 33.5005 44.922 32.4131C45.6416 32.4141 46.2408 32.4151 46.5235 32.4201C47.4561 32.434 48.1428 33.0986 48.1747 33.991Z"
                      fill="white"/>
                    <path
                      d="M51.897 55.6152C53.1043 55.6142 54.1036 56.6211 54.0996 57.8349C54.0946 59.0357 53.1292 60.0038 51.9229 60.0167C50.6917 60.0296 49.7064 59.0616 49.7024 57.8359C49.6984 56.6141 50.6847 55.6162 51.897 55.6152Z"
                      fill="white"/>
                    <path
                      d="M59.4562 55.6145C60.6635 55.5956 61.6707 56.5885 61.6787 57.8063C61.6866 59.038 60.7192 60.014 59.488 60.016C58.2807 60.018 57.3024 59.0629 57.2825 57.863C57.2616 56.6502 58.2449 55.6334 59.4562 55.6145Z"
                      fill="white"/>
                    <path
                      d="M44.2969 41.1768C45.547 41.1718 46.5314 42.1428 46.5184 43.3686C46.5065 44.5644 45.5192 45.5474 44.3228 45.5554C43.0996 45.5633 42.1093 44.5734 42.1133 43.3447C42.1192 42.1209 43.0648 41.1818 44.2969 41.1768Z"
                      fill="white"/>
                    <path
                      d="M67.1059 45.5553C65.8877 45.5723 64.8755 44.5863 64.8615 43.3705C64.8476 42.1478 65.8339 41.1728 67.0791 41.1778C68.3112 41.1827 69.2548 42.1199 69.2597 43.3447C69.2647 44.5545 68.3053 45.5384 67.1059 45.5553Z"
                      fill="white"/>
                    <path
                      d="M51.8751 48.3918C53.0973 48.3739 54.1026 49.3668 54.0996 50.5886C54.0976 51.7835 53.1182 52.7734 51.9199 52.7933C50.7126 52.8122 49.7014 51.8064 49.7014 50.5846C49.7014 49.3748 50.6579 48.4097 51.8751 48.3918Z"
                      fill="white"/>
                    <path
                      d="M59.4661 48.3917C60.6933 48.3788 61.6837 49.3638 61.6797 50.5925C61.6757 51.7953 60.7043 52.7763 59.503 52.7932C58.3007 52.8091 57.2785 51.7913 57.2805 50.5795C57.2825 49.3787 58.2559 48.4047 59.4661 48.3917Z"
                      fill="white"/>
                    <path
                      d="M67.0702 55.6455C68.2954 55.6465 69.2608 56.5917 69.2757 57.8044C69.2897 59.0133 68.2864 60.0211 67.0672 60.0211C65.8539 60.0211 64.8407 59.0043 64.8556 57.8015C64.8696 56.5996 65.8509 55.6445 67.0702 55.6455Z"
                      fill="white"/>
                    <path
                      d="M44.3646 48.4261C45.5938 48.446 46.5473 49.4181 46.5184 50.6209C46.4895 51.8168 45.4942 52.7948 44.3059 52.7938C43.0936 52.7928 42.1003 51.782 42.1132 50.5632C42.1282 49.3186 43.0906 48.4052 44.3646 48.4261Z"
                      fill="white"/>
                    <path
                      d="M67.052 48.4258C68.2981 48.4198 69.2406 49.3282 69.2585 50.5529C69.2765 51.7737 68.2981 52.7805 67.0798 52.7945C65.8805 52.8084 64.8584 51.7896 64.8594 50.5828C64.8613 49.371 65.8178 48.4308 67.052 48.4258Z"
                      fill="white"/>
                    <path
                      d="M44.3067 55.6455C45.528 55.6425 46.5004 56.5887 46.5193 57.7985C46.5382 59.0093 45.5399 60.0132 44.3147 60.0161C43.0855 60.0201 42.1042 59.0332 42.1151 57.8055C42.1261 56.5817 43.0736 55.6485 44.3067 55.6455Z"
                      fill="white"/>
                    <defs>
                      <filter id="filter0_d_621_17550" x="0.0751953" y="0.0751953" width="110.85" height="110.85"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="5"/>
                        <feGaussianBlur stdDeviation="7.5"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_621_17550"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_621_17550" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div class="section-9__item--title mob">Крок 4</div>
              </div>
              <div class="section-9__item--content">
                <div class="section-9__item--title desc">Крок 4</div>
                <div class="section-9__item--text">
                  <strong>Кардіовертер-дефібрилятор передається в медичний заклад,</strong> де буде проведено необхідне
                  лікування.
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="section-9__img desc">
          <img src="@/assets/img/implantation/photo-3-top.png" alt="">
          <img src="@/assets/img/implantation/photo-3.png">
          <img src="@/assets/img/implantation/photo-3-bottom.png" alt="">
        </div>
        <img class="section-9__img mob" src="@/assets/img/implantation/photo-3-mob.png">
      </div>
    </section>
    <section class="section-10">
      <p class="section-10__text">*Фото моделі, що не є реальним портретом пацієнта, використовується за ліцензією
        Shutterstock</p>
      <div class="section-10__subtitle">Джерела:</div>
      <ul class="section-10__list">
        <li class="section-10__item">
          <p class="section-10__text"><strong>1. </strong>Імплантований кардіовертер-дефібрилятор (ІКД). <a
            href="https://scd.com.ua/article/2-implantovaniy_kardioverter-defibrilyator_ikd" target="_blank"
            class="section-10__link">https://scd.com.ua/article/2-implantovaniy_kardioverter-defibrilyator_ikd</a>(дата
            звернення: 27.08.2021).</p>
        </li>
        <li class="section-10__item">
          <p class="section-10__text"><strong>2. </strong>CEMA Innovation Fund «Increasing number of ICD implantations
            in primary prevention (PP)», November 25, 2020, Confidential, for Internal Use Only.</p>
        </li>
        <li class="section-10__item">
          <p class="section-10__text"><strong>3. </strong>Priori SG et al. ESC Scientific Document Group. 2015 ESC
            Guidelines for the management of patients with ventricular arrhythmias and the prevention of sudden cardiac
            death: The Task Force for the Management of Patients with Ventricular Arrhythmias and the Prevention of
            Sudden Cardiac Death of the European Society of Cardiology (ESC). Endorsed by: Association for European
            Paediatric and Congenital Cardiology (AEPC). Eur Heart J. 2015 Nov 1;36(41):2793-2867.</p>
        </li>
        <li class="section-10__item">
          <p class="section-10__text"><strong>4. </strong>Al-Khatib SM. et al. 2017 AHA/ACC/HRS guideline for management
            of patients with ventricular arrhythmias and the prevention of sudden cardiac death: Executive summary: A
            Report of the American College of Cardiology/American Heart Association Task Force on Clinical Practice
            Guidelines and the Heart Rhythm Society. Heart Rhythm. 2018 Oct;15(10):e190-e252.</p>
        </li>
        <li class="section-10__item">
          <p class="section-10__text"><strong>5. </strong>Наказ МОЗ України від 01.07.2021 №1319 «Про розподіл медичних
            виробів для електрофізіології та кардіостимуляції для лікування хворих із серцево-судинними та
            судинно-мозковими захворюваннями, закуплених за кошти...». <a
              href="https://moz.gov.ua/article/ministry-mandates/nakaz-moz-ukraini-vid-01072021--1319-pro-rozpodil-medichnih-virobiv-dlja-elektrofiziologii-ta-kardiostimuljacii-dlja-likuvannja-hvorih-iz-sercevo-sudinnimi-ta-sudinno-mozkovimi-zahvorjuvannjami-zakuplenih-za-koshti"
              target="_blank" class="section-10__link">https://moz.gov.ua/article/ministry-mandates/nakaz-moz-ukraini-vid-01072021--1319-pro-rozpodil-medichnih-virobiv-dlja-elektrofiziologii-ta-kardiostimuljacii-dlja-likuvannja-hvorih-iz-sercevo-sudinnimi-ta-sudinno-mozkovimi-zahvorjuvannjami-zakuplenih-za-koshti</a>
            (дата звернення: 27.08.2021).</p>
        </li>
        <li class="section-10__item">
          <p class="section-10__text"><strong>6. </strong>Як безоплатно отримати кардіостимулятор або
            кардіовертер-дефібрілятор, закуплений МОЗ України. <a
              href="https://scd.com.ua/mdarticle/39-yak_bezoplatno_otrimati_kardiostimulyator_abo_kardioverter-defibrilyator_zakupleniy_moz_ukraini"
              target="_blank" class="section-10__link">https://scd.com.ua/mdarticle/39-yak_bezoplatno_otrimati_kardiostimulyator_abo_kardioverter-defibrilyator_zakupleniy_moz_ukraini</a>
            (дата звернення: 27.08.2021).</p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import getElementVisible from '@/helper'
import Header from '../components/Header.vue'
import TopSection from '../components/TopSection.vue'

export default {
  name: 'Implantation',
  components: {
    Header,
    TopSection
  },
  data() {
    return {
      state: '',
      currentState: '',
      trigger25: true,
      trigger50: true,
      trigger75: true,
      trigger90: true,
    }
  },
  computed: {
    ...mapGetters(['getVisibleStage'])
  },
  methods: {
    ...mapMutations([
      'setRestart'
    ]),
    changeState(value) {
      this.currentState = value
      localStorage.setItem('implantCurrentState', value)
      if (this.state !== this.currentState) {
        this.state = value
        localStorage.setItem('implantState', value)
      }
      this.scrollToActiveMenu()
    },
    scrollToActiveMenu() {
      var menu = document.querySelector('.bottom-nav')
      var menuItems = document.querySelectorAll('.bottom-list__item')

      menuItems.forEach((item, key) => {
        if (item.hash === window.location.hash) {
          menu.scrollLeft = menuItems[key].offsetLeft
        }
      })
    },
    chartAnimation() {
      const bars = document.querySelectorAll('.chart__bar')

      bars.forEach((bar, i) => {
        bar.style.opacity = '1'
        switch (i) {
          case 0:
            bar.style.height = '12%'
            break
          case 1:
            bar.style.height = '8%'
            break
          case 2:
            bar.style.height = '14%'
            break
          case 3:
            bar.style.height = '18%'
            break
          case 4:
            bar.style.height = '15%'
            break
          case 5:
            bar.style.height = '14%'
            break
          case 6:
            bar.style.height = '13%'
            break
          case 7:
            bar.style.height = '18%'
            break
          case 8:
            bar.style.height = '39%'
            break
          case 9:
            bar.style.height = '62%'
            break
          case 10:
            bar.style.height = '82%'
            break
          case 11:
            bar.style.height = '92%'
            break
          default:
            break
        }
      })
    }
  },
  mounted() {
    if (localStorage.getItem('implantCurrentState') !== null) {
      this.currentState = localStorage.getItem('implantCurrentState')
    }
    if (localStorage.getItem('implantState') !== null) {
      this.state = localStorage.getItem('implantState')
    }
    this.scrollToActiveMenu()


    document.addEventListener('scroll', () => {

      var h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';

      var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);

      if (percent >= 25 && percent < 50 && this.trigger25) {
        this.trigger25 = false
        gtag('event', 'scroll_view', {'scroll_percent': 'moreThan25%'})
      } else if (percent >= 50 && percent < 75 && this.trigger50) {
        this.trigger50 = false
        gtag('event', 'scroll_view', {'scroll_percent': 'moreThan50%'})
      } else if (percent >= 75 && percent < 90 && this.trigger75) {
        this.trigger75 = false
        gtag('event', 'scroll_view', {'scroll_percent': 'moreThan75%'})
      } else if (percent >= 90 && this.trigger90) {
        this.trigger90 = false
        gtag('event', 'scroll_view', {'scroll_percent': 'moreThan90%'})
      }
    });

    const headings = document.querySelectorAll('.anchor')
    document.addEventListener('scroll', this.animate)
    window.addEventListener('scroll', () => {
      headings.forEach((ha) => {
        const rect = ha.getBoundingClientRect()
        if (rect.top > 0 && rect.top < 150) {
          const location = window.location.toString().split('#')[0]
          history.replaceState(null, null, location + '#' + ha.id)

          if (ha.id === 'composition') {
            const listDecor = document.querySelector('.list__decor')
            listDecor.classList.add('anim-path')
          }
        }
      })

      if (getElementVisible('implantation-count')) {
        this.chartAnimation()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
$fontR: "Montserrat-Regular";
$fontM: "Montserrat-Medium";
$fontB: "Montserrat-Bold";
$fontSB: "Montserrat-SemiBold";

.main-btn {
  background: #285EFF;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
  border-radius: 50px;
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 50px;
  width: 234px;
  //min-width: 234px;
  position: relative;
  z-index: 2;
  transition: all .5s ease-in-out;
  -webkit-tap-highlight-color: transparent !important;

  &.sticky {
    position: sticky;
    // top: 90vh;
    top: 590px;
    right: 20px;
    z-index: 9;

    margin-right: 0;
    margin-left: auto;

    display: none;

    transform: translateY(-90px);

    @media screen and (max-width: 1020px) {
      display: flex;
    }
  }

  &__text {
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    line-height: 110%;
    font-family: $fontM;
    text-align: left;
    max-width: 141px;
    position: relative;
    z-index: 2;
    transform: translateX(35px);
    transition: all .5s ease-in-out;
  }

  &__decor {
    border: 1px solid #FFFFFF;
    border-radius: 50px;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto 0;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      //top: 6px;
      //position: absolute;
      //left: 11px;
    }

    &.after {
      transition: all .5s ease-in-out;
    }

  }

  &:hover {
    & > .main-btn__text {
      transform: translateX(60px);
      @media screen and (max-width: 540px) {
        transform: translateX(40px) !important;
      }
    }

    & > .main-btn__decor {
      &.after {
        right: calc(100% - 40px);

        @media screen and (max-width: 540px) {
          right: calc(100% - 29px);
        }
      }
    }
  }

  &:active {
    background-color: #DC1B85;

    svg path {
      stroke: #DC1B85;
    }
  }
}


.secondary-btn {
  background: #FB35A2;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
  border-radius: 50px;
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 50px;
  width: 234px;
  max-width: 234px;
  transition: all .31s;

  position: relative;

  &__text {
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    line-height: 110%;
    font-family: $fontM;
    text-align: left;
    max-width: 141px;
    position: relative;
    z-index: 2;
    transform: translateX(35px);
    transition: all .5s ease-in-out;
  }

  &__decor {
    border: 1px solid #FFFFFF;
    border-radius: 50px;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto 0;

    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      display: block;
    }

    &.after {
      transition: all .5s ease-in-out;
    }
  }

  &:hover {
    & > .secondary-btn__text {
      transform: translateX(60px);
      @media screen and (max-width: 540px) {
        transform: translateX(40px) !important;
      }
    }

    & > .secondary-btn__decor {
      &.after {
        right: calc(100% - 40px);

        @media screen and (max-width: 540px) {
          right: calc(100% - 29px);
        }
      }
    }
  }

  &:active {
    background-color: #DC1B85;

  }
}

.implantation {
  width: 100%;
  // overflow-x: hidden;
  position: relative;

  .section-2 {
    margin: 0 5%;
    background: #285EFF;
    box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.15);
    border-radius: 50px;
    // transform: matrix(-1, 0, 0, 1, 0, 0);
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 7%;

    &__img {
      object-fit: contain;
      max-width: 558px;
      display: block;

      &.mob {
        display: none;
      }
    }

    &__subtitle {
      font-size: 48px;
      line-height: 110%;
      font-family: $fontM;
      font-weight: 500;
      text-align: left;
    }

    &__content {
      color: #FFFFFF;
      width: 44%;
    }

    &__text {
      font-size: 24px;
      line-height: 29px;
      text-align: left;
      width: 80%;
      margin-top: 18px;
    }
  }

  .section-3 {
    margin-top: 156px;
    display: grid;
    grid-template-columns: 51% 38%;
    grid-column-gap: 10%;
    padding: 0 13%;
    max-width: 100%;

    &__img-wrapper {
      position: relative;

      img {
        object-fit: contain;
        max-width: 100%;
      }

      .rings {
        position: absolute;
        top: calc(100% - 151px / 2);
        right: 30px;
        border-radius: 50%;
        border: 4px solid #FB35A2;
        width: 151px;
        height: 151px;
        max-width: 151px;
        max-height: 151px;
        filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.15));
        animation-duration: 2.0s;
        animation-name: pulse_1;
        animation-iteration-count: infinite;

        &:nth-of-type(2) {
          animation-name: pulse_2;
        }

        &:nth-of-type(3) {
          animation-name: pulse_3;
        }
      }

      svg {
        position: absolute;
        top: calc(100% - 141px / 2);
        right: 30px;
      }
    }

    &__left--text-wrapper {
      margin-top: 26px;
    }

    &__text {
      font-size: 20px;
      line-height: 24px;
      color: #3C3C3C;
      font-family: $fontR;
      font-weight: 400;
      text-align: left;
      width: 70%;

      strong {
        font-family: $fontSB;
      }
    }

    &__subtitle {
      font-size: 48px;
      line-height: 110%;
      font-family: $fontM;
      font-weight: 500;
      text-align: left;
      margin-top: 10px;

      span {
        font-size: 55px;
      }
    }

    &__right {
      &--list {
        .list__item {
          font-size: 18px;
          line-height: 22px;
          padding-top: 20px;
          border-top: 1px solid #3C3C3C;
          text-align: left;

          &:nth-of-type(2) {
            padding-bottom: 20px;
          }

          &:last-of-type {
            border-bottom: 1px solid #3C3C3C;
          }

          span {
            display: inline-block;
            font-size: 28px;
            line-height: 115%;
            font-family: $fontM;
            margin-top: 15px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  .section-4 {
    margin-top: 155px;
    margin-bottom: 104px;
    background-color: rgba(40, 94, 255, .15);
    background-image: url('../assets/img/implantation/section-4-bg.png');
    background-position-x: 100%;
    background-repeat: no-repeat;
    padding: 96px 11% 96px 13%;
    min-height: 429px;
    max-height: 429px;
    height: 100%;

    display: flex;

    &__title {
      font-size: 36px;
      line-height: 110%;
      font-family: $fontM;
      font-weight: 500;
      text-align: left;
      margin-bottom: 42px;
    }

    &__right {
      background: #FFFFFF;
      border: 1px solid #3C3C3C;
      border-radius: 38px;
      width: 100%;
      max-width: 738px
      // margin-left: 37px;
    }

    &__left {
      width: 51%;
      padding-right: 37px;
    }

    & > .main-btn.mob {
      display: none;
    }

    .chart {
      max-height: 236px;
      height: 236px !important;
      padding: 20px 32px;
      padding-bottom: 40px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      position: relative;

      &::after {
        content: '';
        width: 91%;
        height: .8px;
        background: #CCCCCC;
        position: absolute;
        bottom: 40px;
      }

      &__bar {
        background: rgba(40, 94, 255, .15);
        width: 32px;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        position: relative;
        transition-duration: .5s;
        transition-delay: .1s;
        transition-timing-function: ease-in-out;
        cursor: pointer;
        opacity: 0;
        height: 4%;

        display: flex;
        justify-content: center;

        .year {
          color: #3C3C3C;
          font-size: 14px;
          line-height: 110%;
          position: absolute;
          bottom: -22px;
          left: 2px;
        }

        .count {
          position: absolute;
          top: -28px;

          color: #285EFF;
          font-family: $fontSB;
          font-weight: 600;
          font-size: 19px;
        }

        img {
          position: absolute;
          top: -6px;
          left: -4px;
          max-height: 20px;
        }

        &:nth-of-type(1) {
          transition-delay: .0s;
        }

        &:nth-of-type(2) {
          transition-delay: .01s;
        }

        &:nth-of-type(3) {
          transition-delay: .02s;
        }

        &:nth-of-type(4) {
          transition-delay: .03s;
        }

        &:nth-of-type(5) {
          transition-delay: .04s;
        }

        &:nth-of-type(6) {
          transition-delay: .05s;
        }

        &:nth-of-type(7) {
          transition-delay: .06s;
        }

        &:nth-of-type(8) {
          transition-delay: .07s;
        }

        &:nth-of-type(9) {
          transition-delay: .08s;
        }

        &:nth-of-type(10) {
          transition-delay: .09s;
        }

        &:nth-of-type(11) {
          transition-delay: 0.1s;
        }
      }
    }
  }

  .section-5 {
    margin: 0 5%;

    &__title {
      font-size: 64px;
      line-height: 110%;
      font-family: $fontM;
      font-weight: 500;
      text-align: left;
      padding-left: 8%;
      margin-bottom: 55px;
    }

    &__container {
      // background: #E9E9E9;
      // box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      // border-radius: 50px;
      width: 100%;
      height: 100%;
      // min-height: 684px;
      // max-height: 684px;
      position: relative;

      img {
        max-width: 100%;
        object-fit: contain;
      }

      .video-btn {
        width: 90px;
        height: 90px;
        background-color: #285EFF;
        background-image: url('../assets/img/implantation/play.svg');
        background-repeat: no-repeat;
        background-position: 31px;
        border-radius: 50%;
        position: absolute;
        top: calc(50% - 90px / 2);
        left: calc(50% - 90px / 2);
        cursor: pointer;
      }
    }
  }

  .section-6 {
    margin-top: 150px;
    align-items: center;
    display: flex;
    max-width: 1007px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    justify-content: space-between;

    &__left {
      position: relative;

      img {
        object-fit: contain;
        max-width: 414px;
      }

      .img-decor {
        width: 36px;
        height: 36px;
        border: 3px solid #285EFF;
        border-radius: 50%;
        position: absolute;
        background-color: transparent;
        display: none;
        justify-content: center;
        align-items: center;

        &.top {
          top: 25%;
          right: 38%;
        }

        &.bottom {
          right: 13%;
          top: 64%;
        }

        &__inside {
          background-color: #285EFF;
          border-radius: 50%;
          width: 24px;
          height: 24px;
        }
      }
    }

    &__right {
      max-width: 500px;
    }

    &__subtitle {
      font-weight: 500;
      font-size: 64px;
      line-height: 110%;
      font-family: $fontM;
      text-align: left;
    }

    .list {
      position: relative;
      width: 100%;

      &__decor {
        position: absolute;
        left: -59%;
        bottom: 36%;

        &.anim-path path {
          animation: draw 2s linear;
        }

        svg {
          max-width: 300px;
        }
      }

      &__item {
        font-size: 24px;
        line-height: 29px;
        margin-top: 28px;
        text-align: left;
        padding-left: 18px;
      }
    }
  }

  .section-7 {
    margin-top: 160px;
    background-color: rgba(40, 94, 255, .15);
    padding: 104px 11% 125px 13%;
    height: 100%;

    &__subtitle {
      font-weight: 500;
      font-size: 64px;
      line-height: 110%;
      font-family: $fontM;
      text-align: left;
    }

    &__list {
      display: flex;
      justify-content: space-between;
      margin-top: 45px;
      -webkit-tap-highlight-color: transparent;
    }

    &__text {
      text-align: left;
      font-size: 24px;
      line-height: 29px;
      font-weight: 500;
      font-family: $fontM;

      &.mob {
        display: none;
      }
    }

    &__item {
      border: 1px solid #3C3C3C;
      background: #FFFFFF;
      padding: 20px 20px 37px 28px;
      max-width: 314px;
      border-radius: 50px;
      display: flex;
      flex-direction: column;

      -webkit-tap-highlight-color: transparent;

      &--container {
        position: relative;
        text-align: right;
        width: 120px;
        height: 120px;
        align-self: flex-end;

        .rings {
          position: absolute;
          left: 4px;
          top: -1px;
          border-radius: 50%;
          border: 4px solid #285EFF;
          width: 112px;
          height: 112px;
          max-width: 112px;
          max-height: 112px;
          filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.15));
          animation-duration: 2.0s;
          animation-iteration-count: infinite;
        }
      }

      &:nth-of-type(1) {
        .section-7__text {
          width: 80%;
        }
      }

      &:nth-of-type(2) {
        .section-7__text {
          width: 74%;
        }
      }

      &:hover,
      &:active {
        .rings {
          animation-name: pulse_1;

          &:nth-of-type(2) {
            animation-name: pulse_2;
          }

          &:nth-of-type(3) {
            animation-name: pulse_3;
          }
        }
      }
    }

    &__middle {
      margin-top: 49px;
      display: grid;
      grid-template-columns: 37% 36%;
      grid-column-gap: 15%;
    }

    &__bottom {
      background: #285EFF;
      border-radius: 50px;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      padding: 20px 62px 0 72px;
      margin-top: 70px;
      display: flex;
      min-height: 549px;
      justify-content: space-between;

      &--img {
        max-width: 470px;
        width: 100%;
        object-fit: contain;
        transform: translateY(5px);
      }

      &--wrapper {
        height: 100%;
        align-self: flex-end;
        position: relative;
        overflow: hidden;

        svg {
          position: absolute;
          right: 27.6%;
          top: 47.6%;
        }

        .rings {
          position: absolute;
          right: 30%;
          top: 48%;
          border-radius: 50%;
          border: 3px solid #FB35A2;
          width: 101px;
          height: 101px;
          max-width: 101px;
          max-height: 101px;
          filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.15));
          animation-duration: 2.0s;
          animation-iteration-count: infinite;
          animation-name: pulse_1;

          &:nth-of-type(2) {
            animation-name: pulse_2;
          }

          &:nth-of-type(3) {
            animation-name: pulse_3;
          }
        }
      }

      &--content {
        color: #FFFFFF;
        text-align: left;
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      &--text {
        font-size: 24px;
        // line-height: 29px;
      }

      &--descr {
        font-family: $fontM;
        font-weight: 500;
        font-size: 33px;
        line-height: 120%;
        margin-top: 12px;
      }

      &--num {
        font-family: $fontM;
        font-weight: 500;
        font-size: 48px;
        line-height: 110%;
        margin-bottom: 11px;

        sup {
          font-size: 52%;
        }
      }
    }
  }

  .section-8 {
    padding: 61px 178px 125px 179px;
    background-image: url('../assets/img/heart-banner.svg');
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: 60px;

    &__title {
      font-family: $fontM;
      font-weight: 500;
      font-size: 64px;
      line-height: 110%;
      text-align: left;

      margin-bottom: 23px;
    }

    &__description {
      font-size: 24px;
      line-height: 29px;
      text-align: left;

      width: 68%;

      margin-bottom: 23px;
    }

    &__subtitle {
      font-family: $fontSB;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      text-align: left;

      width: 68%;
    }

    &__list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 30px;
      grid-row-gap: 70px;

      margin-top: 77px;
    }

    &__item {
      background: #FFF5FA;
      border: 1px solid #3C3C3C;
      border-radius: 50px;
      padding: 52px 20px 33px 28px;

      position: relative;
      text-align: left;

      &--wrapper {
        position: absolute;
        bottom: calc(100% - 83px / 2);
        left: calc(50% - 83px / 2);

        width: 83px;
        height: 83px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
        border: 4px solid #FB35A2;
        background: #FFFFFF;
        border-radius: 50%;
      }

      &--num {
        width: 60px;
        height: 60px;
        background: #FB35A2;

        font-weight: 500;
        font-size: 48px;
        font-family: $fontM;
        line-height: 110%;
        color: #FFFFFF;
        border-radius: 50%;
        text-align: center;
        margin: 7px auto;
      }

      &--text {
        font-size: 18px;
        line-height: 22px;
        position: relative;
        z-index: 1;

        strong {
          font-family: $fontSB;
          font-weight: 600;
        }
      }
    }

    .secondary-btn {
      // margin: 52px auto 116px auto; should uncomment when bottom section will be visible
      margin: 52px auto 0 auto;
    }

    &__bottom {
      // padding-bottom: 125px;
      &--subtitle {
        font-size: 30px;
        line-height: 37px;
        font-weight: 400;
        display: flex;
        align-items: center;
        text-align: left;
        margin-bottom: 49px;

        .warning {
          margin-right: 30px;
        }
      }

      &--list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 25px;
      }

      &--item {
        border-top: 1px solid #3C3C3C;
        padding-top: 18px;
        display: flex;
        flex-direction: column;
      }

      &--text {
        font-family: $fontSB;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 16px;
        text-align: left;
      }

      &--link {
        color: #FB35A2;
        font-size: 16px;
        line-height: 20px;
        text-align: left;
        cursor: pointer;
        transition: color .1s ease;

        &:hover {
          color: #D32183;
        }

        &:visited {
          color: #8C23DE;
        }
      }
    }
  }

  .section-9 {
    &__img {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      img {
        max-width: 460px;
        width: 100%;
        height: auto;
        display: block;
      }

      &.mob {
        display: none;
      }
    }

    &__top {
      padding: 71px 178px 164px 180px;
      background: rgba(40, 94, 255, .15);
    }

    &__title {
      font-family: $fontM;
      font-weight: 500;
      font-size: 64px;
      line-height: 110%;
      text-align: left;
      margin-bottom: 36px;
    }

    &__description {
      display: flex;
      align-items: flex-start;

      & > .section-9__text {
        font-size: 16px;
        line-height: 20px;
        text-align: left;
        // width: 70%;
      }

      strong {
        font-family: $fontSB;
      }

      img {
        margin-right: 20px;
        max-width: 104px;
      }
    }

    &__bottom {
      background-color: #285EFF;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      border-radius: 50px;
      transform: translateY(-40px);
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      padding-left: 180px;


      & > .right {
        display: flex;
        justify-content: flex-end;

        img {
          width: 70%;
          height: 100%;
        }
      }

      & > .left {
        padding-top: 60px;
        padding-bottom: 75px;
      }
    }

    &__subtitle {
      font-size: 36px;
      line-height: 110%;
      color: #FFFFFF;
      font-weight: 400;
      text-align: left;
      margin-bottom: 30px;
      max-width: 679px;
    }

    &__list {
      position: relative;
      max-width: 623px;

      -webkit-tap-highlight-color: transparent;

      &::after {
        content: '';
        width: 4px;
        height: 90%;
        background-color: #FFFFFF;
        position: absolute;
        left: 71px;
        top: 0;
      }
    }

    &__item {
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      margin-bottom: 25px;
      border-radius: 50px;
      position: relative;
      z-index: 1;
      padding: 20px;
      padding-right: 32px;

      display: flex;

      -webkit-tap-highlight-color: transparent;

      &--content {
        margin-left: 17px;
      }

      &--title {
        font-size: 30px;
        line-height: 37px;
        font-family: $fontM;
        font-weight: 500;
        text-align: left;

        &.mob {
          display: none;
        }
      }

      &--text {
        margin-top: 6px;
        text-align: left;
        font-size: 16px;
        line-height: 20px;
      }

      &:nth-of-type(1) {
        .section-9__item--text {
          width: 86%;
        }
      }

      &:nth-of-type(2) {
        .section-9__item--text {
          width: 92%;
        }
      }

      &:nth-of-type(3) {
        .section-9__item--text {
          width: 87%;
        }
      }

      &:nth-of-type(4) {
        .section-9__item--text {
          width: 70%;
        }
      }

      &--containter {
        position: relative;
      }

      .rings {
        position: absolute;
        left: 24px;
        border-radius: 50%;
        border: 3px solid #FB35A2;
        width: 103px;
        height: 103px;
        max-width: 103px;
        max-height: 103px;
        filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.15));
        animation-duration: 2.0s;
        animation-iteration-count: infinite;
      }

      &:hover {
        .rings {
          animation-name: pulse_1;

          &:nth-of-type(2) {
            animation-name: pulse_2;
          }

          &:nth-of-type(3) {
            animation-name: pulse_3;
          }
        }
      }
    }
  }

  .section-10 {
    text-align: left;
    padding: 34px 75px 56px 75px;
    overflow-x: hidden;

    &__subtitle {
      margin-top: 12px;
      font-family: $fontB;
      font-weight: 700;
    }

    &__text {
      font-size: 13px;
      line-height: 16px;
    }

    &__link {
      color: #FB35A2;

      cursor: pointer;
      transition: color .1s ease;

      &:hover {
        color: #D32183;
      }

      &:visited {
        color: #8C23DE;
      }

      &:active {
        color: #FB35A2;
      }
    }

  }
}

@media screen and (max-width: 1200px) {
  .implantation {
    .section-2 {
      &__subtitle {
        font-size: 36px;
      }

      &__text {
        font-size: 20px;
        width: 90%;
      }

      &__img {
        display: block;
        max-width: 440px;
      }
    }

    .section-3 {
      margin-top: 90px;

      &__subtitle {
        font-size: 36px;

        span {
          font-size: 44px;
        }
      }

      &__img-wrapper {
        .rings {
          right: 20px;
        }

        svg {
          right: 20px;
        }
      }

      &__right--list {
        .list__item {
          padding: 28px 0;

          span {
            font-size: 24px;
          }
        }
      }
    }

    .section-4 {
      margin-top: 90px;
      margin-bottom: 90px;

      &__title {
        font-size: 32px;
      }
    }

    .section-5 {
      &__title {
        font-size: 56px;
        margin-bottom: 48px;
      }
    }

    .section-6 {
      &__subtitle {
        font-size: 56px;
      }
    }

    .section-7 {
      margin-top: 120px;
      padding-bottom: 96px;

      &__subtitle {
        font-size: 56px;
      }

      &__list {
        margin-top: 36px;
      }

      &__item {
        padding: 12px 12px 28px 20px;
        width: 232px;

        &:nth-of-type(2) {
          .section-7__text {
            width: 90%;
          }
        }

        &:nth-of-type(3) {
          .section-7__text {
            width: 90%;
          }
        }
      }

      &__text {
        font-size: 22px;
        line-height: 26px;
        width: 90%;
      }

      &__middle {
        grid-column-gap: 10%;
        grid-template-columns: 38% 38%;
      }

      &__bottom {
        padding: 20px 42px 0 52px;

        &--text {
          font-size: 22px;
          line-height: 26px;
        }

        &--descr {
          font-size: 28px;
        }

        &--num {
          font-size: 36px;
        }
      }
    }

    .section-8 {
      padding-bottom: 90px;

      &__title {
        font-size: 56px;
      }

      &__subtitle,
      &__description {
        font-size: 22px;
        line-height: 26px;
      }

      &__item {
        padding: 48px 16px 28px 22px;
      }

      &__bottom {
        // padding-bottom: 90px;
        &--subtitle {
          font-size: 26px;
          line-height: 33px;
          margin-bottom: 38px;
        }

        &--list {
          grid-template-columns: repeat(2, 1fr);
          grid-row-gap: 10%;
        }
      }

      .secondary-btn {
        margin: 44px auto 86px auto;
      }
    }

    .section-9 {
      &__title {
        font-size: 56px;
      }

      &__top {
        padding-bottom: 120px;
      }

      &__subtitle {
        font-size: 32px;
        max-width: 623px;
      }

      &__img {
        display: block;

        &.desc {
          display: none;
        }

        &.mob {
          display: block;
        }
      }

      &__bottom {
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        padding: 0 5%;
      }

      &__list {
        margin: 0 auto;
      }
    }
  }
}

@media screen and (max-width: 940px) {
  .main-btn {
    &__text {
      font-size: 14px;
    }
  }
  .implantation {
    .main-btn.sticky {
      transform: translateY(-108px);
    }

    .section-2 {
      flex-direction: column;
      padding: 0;
      overflow: hidden;
      padding-bottom: 36px;
      // border-radius: 30px;
      &__img {
        display: block;
        max-width: unset;
        width: 100%;
        transform: translateY(-16px);
        margin-bottom: 24px;

        &.desc {
          display: none;
        }

        &.mob {
          display: block;
        }
      }

      &__content {
        width: 86%;
      }
    }

    .section-3 {
      grid-template-columns: 1fr;

      &__subtitle {
        margin-bottom: 43px;
      }
    }

    .section-4 {
      padding: 30px;
      flex-direction: column;
      min-height: 480px;
      max-height: 480px;
      background-position-y: 158%;

      &__title {
        margin-bottom: 30px;
        font-size: 26px;
      }

      &__right {
        width: 100%;
      }

      & > .main-btn.mob {
        display: flex;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
        width: 150px;
        height: 32px;

        .main-btn__text {
          max-width: 89px;
          font-size: 10px;
          transform: translateX(22px);
        }

        .main-btn__decor {
          width: 19px;
          height: 19px;
          //transform: translateX(40px);

          svg {
            width: 5px;
            height: 9px;
            //top: -2px;
            //left: 1px;
          }
        }

        &:active {
          background-color: #1646D6;

          & > .main-btn__decor.after {
            //transform: translateX(-66px);
          }

          & > .main-btn__text {
            //transform: translateX(50px);
          }
        }
      }

      .main-btn.desc {
        display: none;
      }

      .chart::after {
        width: 93%;
      }
    }

    .section-5 {
      &__title {
        font-size: 48px;
        line-height: 52px;
      }
    }

    .section-6 {
      margin-top: 90px;
      flex-direction: column;

      &__subtitle {
        font-size: 48px;
      }

      &__right {
        max-width: 600px;
        margin-top: 40px;
      }

      &__left {
        .img-decor {
          display: flex;
        }

        img {
          max-width: 600px;
        }
      }

      .list {
        li {
          position: relative;
        }

        li::before {
          content: "•";
          color: #285EFF;
          position: absolute;
          left: 0px;
          font-size: 80px;
          transform: translateY(-4px);
        }

        &__decor {
          display: none;
        }
      }
    }

    .section-7 {
      padding: 30px;

      &__subtitle {
        font-size: 48px;
      }

      &__list {
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 20px;
      }

      &__item {
        width: 100%;
        max-width: 100%;
        flex-direction: row-reverse;
        align-items: center;
        padding: 23px;
      }

      &__text {
        width: 100%;

        &.desc {
          display: none;
        }

        &.mob {
          display: block;
        }
      }

      &__middle {
        grid-template-columns: 1fr;
        grid-row-gap: 17px;
      }

      &__bottom {
        flex-direction: column;

        &--content {
          width: 90%;
        }

        &--wrapper {
          align-self: center;
        }
      }
    }

    .section-8 {
      padding: 42px 20px 50px 20px;

      &__title {
        font-size: 48px;
      }
    }

    .section-9 {
      &__title {
        font-size: 48px;
      }

      &__top {
        padding: 37px 20px 89px 20px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .implantation {
    .section-2 {
      &__subtitle {
        font-size: 28px;
      }
    }

    .section-3 {
      &__subtitle {
        font-size: 28px;
        line-height: 30px;

        span {
          font-size: 40px;
        }
      }

      .list {
        &__item {
          padding-top: 28px;

          &:nth-of-type(2) {
            strong {
              &:nth-of-type(2) {
                br {
                  display: none;
                }
              }
            }
          }

          strong {
            white-space: nowrap;
          }
        }
      }
    }

    .section-4 {
      .chart::after {
        width: 91%;
      }
    }

    .section-5 {
      &__title {
        font-size: 36px;
        line-height: 48px;
      }

      &__container {
        min-height: 464px;
        max-height: 464px;
      }
    }

    .section-6 {
      &__left {
        img {
          max-width: 480px;
        }
      }

      &__right {
        max-width: 480px;
      }

      &__subtitle {
        font-size: 36px;
      }

      .list__item {
        padding-left: 32px;
      }
    }

    .section-7 {
      &__subtitle {
        font-size: 36px;
      }

      &__bottom {
        &--content {
          width: 100%;
        }
      }
    }

    .section-8 {
      &__title {
        font-size: 36px;
      }

      &__subtitle,
      &__description {
        width: 90%;
      }

      &__list {
        grid-template-columns: 1fr;
      }

      &__item {
        border-radius: 30px;
      }
    }

    .section-9 {
      &__title {
        font-size: 36px;
      }

      &__bottom {
        & > .left {
          padding-top: 36px;
        }

        img {
          width: 76%;
          object-fit: contain;
          min-width: unset;
        }
      }

      &__subtitle {
        font-size: 28px;
      }
    }

    .section-10 {
      padding: 33px 20px 27px 20px;
    }
  }
}

@media screen and (max-width: 540px) {
  .main-btn {
    width: 150px;
    height: 32px;
    min-height: 32px;

    &__text {
      font-size: 10px;
      line-height: 110%;
      transform: translateX(22px);
      max-width: 89px;
    }

    &__decor {
      width: 19px;
      height: 19px;

      &.after {
        //transform: translateX(36px);
      }

      svg {
        position: relative;
        //top: .8px;
        //left: 1px;
        max-width: 5px;
      }
    }
  }
  .implantation {
    .main-btn.sticky {
      transform: translateY(-96px);
    }

    .section-2 {
      margin: 0 20px;

      &__subtitle {
        font-size: 24px;
      }

      &__text {
        margin-top: 14px;
        font-size: 16px;
        line-height: 20px;
      }
    }

    .section-3 {
      margin-top: 70px;
      padding: 0 20px;

      &__img-wrapper {
        svg {
          width: 94px;
          height: 94px;
          top: calc(100% - 88px / 2);
        }

        .rings {
          width: 98px;
          height: 98px;
          max-width: 98px;
          max-height: 98px;
          top: calc(100% - 98px / 2);
        }
      }

      &__text {
        font-size: 16px;
        line-height: 20px;
      }

      &__subtitle {
        font-size: 24px;
      }

      &__right {
        &--list {
          .list__item {
            padding: 22px 0;
            font-size: 16px;
            line-height: 20px;

            span {
              line-height: 100%;
            }

            &:first-of-type {
              padding: 22px 0;
            }
          }
        }
      }
    }

    .section-4 {
      margin-top: 50px;
      margin-bottom: 45px;
      min-height: 309px;
      max-height: 309px;
      background-position-y: 0%;

      &__left {
        width: 100%;
      }

      &__title {
        font-size: 24px;
      }

      &__right {
        border-radius: 17px;
      }

      .chart {
        padding: 9px 15px 20px 15px;
        max-height: 112px;
        height: 112px !important;

        &::after {
          bottom: 20px;
          width: calc(100% - 30px);
        }

        &__bar {
          width: 15px;

          .count {
            font-size: 9px;
            top: -16px;
          }

          img {
            max-height: 10px;
            top: -4px;
            left: -3px;
          }

          .year {
            font-size: 6px;
            bottom: -10px;
          }
        }
      }
    }

    .section-5 {
      margin: 0 20px;

      &__title {
        font-size: 24px;
        padding-left: 0;
        margin-bottom: 30px;
      }

      &__container {
        border-radius: 30px;
        max-height: 280px;
        min-height: 280px;

        .video-btn {
          width: 50px;
          height: 50px;
          top: calc(50% - 50px / 2);
          left: calc(50% - 50px / 2);
          background-size: 26px;
          background-position: 16px;
        }
      }
    }

    .section-6 {
      margin-top: 12px;

      &__subtitle {
        font-size: 24px;
      }

      &__left {
        img {
          max-width: 274px;
        }
      }

      &__right {
        max-width: 440px;
        padding: 0 20px;
      }

      .list {
        &__item {
          font-size: 16px;
          line-height: 19px;
          margin-top: 16px;
          padding-left: 20px;
        }

        li {
          &::before {
            font-size: 50px;
            transform: translateY(-3px);
          }
        }
      }
    }

    .section-7 {
      margin-top: 50px;
      padding: 30px 20px 50px 20px;

      &__list {
        margin-top: 30px;
      }

      &__text {
        font-size: 16px;
      }

      &__middle {
        margin-top: 30px;
      }

      &__bottom {
        margin-top: 34px;
        padding: 30px 22px 0 22px;
        border-radius: 30px;

        &--text {
          font-size: 16px;
          line-height: 20px;
        }

        &--descr {
          font-size: 24px;
          line-height: 120%;
        }
      }
    }

    .section-8 {
      &__title {
        font-size: 24px;
      }

      &__description {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 10px;
      }

      &__subtitle {
        font-size: 16px;
        line-height: 20px;
      }

      &__list {
        grid-row-gap: 60px;
      }

      &__item {
        &--text {
          font-size: 16px;
          line-height: 20px;
        }
      }

      &__bottom {
        &--subtitle {
          flex-direction: column;
          align-items: flex-start;
          font-size: 22px;
          line-height: 27px;
          margin-bottom: 20px;

          .warning {
            margin-bottom: 16px;
          }
        }

        &--list {
          grid-template-columns: 1fr;
          grid-row-gap: 25px;
        }

        &--text {
          margin-bottom: 0;
        }
      }

      .secondary-btn {
        margin: 30px auto 48px auto;
        width: 152px;
        height: 32px;
        min-height: 32px;

        &__text {
          font-size: 10px;
          transform: translateX(22px);
          max-width: 89px;
        }

        &__decor {
          //transform: translateX(40px);
          width: 19px;
          height: 19px;

          svg {
            top: 1px;
            left: 1px;
            max-width: 6px;
          }
        }

        &:hover,
        &:active {
          & > .secondary-btn__decor.after {
            //transform: translateX(-66px);
          }

          & > .secondary-btn__text {
            //transform: translateX(48px);
          }
        }
      }
    }

    .section-9 {
      // &__top {
      //   padding-left: 0px;
      // }
      &__title {
        font-size: 24px;
        margin-bottom: 30px;

        // padding-left: 20px;
        // padding-right: 20px;
      }

      &__description {
        align-items: flex-start;

        img {
          margin-right: 20px;
          // transform: translateY(-8px)
        }

        & > .section-9__text {
          font-size: 16px;
        }
      }

      &__bottom {
        img {
          width: 100%;
        }

        & > .left {
          padding-top: 10px;
        }
      }

      &__subtitle {
        font-size: 24px;
        margin-bottom: 25px;
      }

      &__item {
        flex-direction: column;
        border-radius: 30px;

        &--title.mob {
          display: inline-block;
          margin-left: 16px;
        }

        &--title.desc {
          display: none;
        }

        &--wrapper {
          display: flex;
          align-items: center;
        }

        &--text {
          font-size: 15px;
          line-height: 18px;
        }

        &--content {
          margin-left: 0;
        }

        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4) {
          .section-9__item--text {
            width: 100%;
          }
        }
      }
    }

    .section-10 {
      padding-top: 0;
    }
  }
}

@keyframes draw {
  0% {
    stroke-dashoffset: 0;
    stroke: none;
  }
  100% {
    stroke-dashoffset: 1000;
    stroke: "#285EFF";
  }
}

@keyframes pulse_1 {
  from {
    opacity: 1;
    transform: scale(0.8, 0.8);
  }
  to {
    opacity: 0;
    transform: scale(1.2, 1.2);
  }
}

@keyframes pulse_2 {
  from {
    opacity: 1;
    transform: scale(0.9, 0.9);
  }
  to {
    opacity: 0;
    transform: scale(1.3, 1.3);
  }
}

@keyframes pulse_3 {
  from {
    opacity: 1;
    transform: scale(1, 1);
  }

  to {
    opacity: 0;
    transform: scale(1.4, 1.4);
  }
}
</style>
